export default{
    id: "NHẬN DẠNG",
    dashboard: "bảng điều khiển",
    warning: "Cảnh báo",
    users: "người dùng",
    farms: "trang trại",
    animals: "Động vật",
    action: "Hoạt động",
    actionList: "Danh sách hành động",
    drugInventory: "kho thuốc",
    inseminatorStatistics: "Thống kê máy gieo tinh",
    organizationNTR: "Tổ chức NTR",
    genotypePerformance: "Hiệu suất kiểu gen",
    semenAutomation: "Tự động hóa tinh dịch",
    activityLogs: "Hoạt động đăng nhập",
    username: "Tên tài khoản",
    title: "Tiêu đề",
    deactivated: "hủy kích hoạt",
    name: "Tên",
    email: "E-mail",
    emailAddress: "Địa chỉ email",
    mobileNum: "Số điện thoại",
    emailOrMobile: "Email/Di động",
    role: "Vai trò",
    roles: "vai trò",
    department: "Phòng",
    status: "Trạng thái",
    pages: "trang",
    departments: "các khoa",
    password: "Mật khẩu",
    cancel: "Hủy bỏ",
    submit: "Nộp",
    error: "lỗi",
    success: "thành công",
    Browse: "duyệt",
    orDropYourFileCsvXlsXlsxHere: "hoặc thả tệp của bạn (CSV, XLS, XLSx) tại đây",
    search: "Tìm kiếm",
    apply: "Áp dụng",
    select: "Lựa chọn",
    previous: "Trước",
    mandatory: "Bắt buộc",
    dropYourFileHere: "hoặc thả tệp của bạn (CSV, XLS, XLSx, PDF, Docx, PNG, JPEG) tại đây",
    restoreDefault: "Khôi phục lại mặc định",
    pending: "Chưa giải quyết",
    completed: "Hoàn thành",
    remove: "Di dời",
    update: "Cập nhật",
    removeFile: "Xóa tệp",
    uploadFile: "Cập nhật dử liệu",
    pleaseChoosePreferedLanguage: "Vui lòng chọn ngôn ngữ ưa thích của bạn",
    edit: "Biên tập",
    activate: "Kích hoạt",
    deactivate: "hủy kích hoạt",
    recievedOrders: "Đơn hàng đã nhận",
    chartRepresentation: "Biểu diễn biểu đồ",
    nameIsRequired: "Tên là bắt buộc",
    export: "Xuất khẩu",
    noFilesAvailable: "KHÔNG CÓ TẬP TIN",
    selectDepartmentToshowRoles: "Chọn một bộ phận để hiển thị vai trò",
    selectDepartmentWithActiveRoles: "Chọn một bộ phận có vai trò tích cực",
    nameCanContainOnlyAlphabets: "Tên chỉ có thể chứa bảng chữ cái",
    nameMustBeLessThan15Chars: "Tên phải ít hơn 30 ký tự",
    emailRequired: "Email thì cần thiết",
    invalidEmailFormat: "Định dạng Email không hợp lệ",
    mobNumReq: "Số điện thoại di động là bắt buộc",
    invalidMobFormat: "Định dạng số điện thoại di động không hợp lệ.",
    passwordRequired: "Mật khẩu là bắt buộc",
    departmentReq: "bộ phận được yêu cầu",
    roleReq: "vai trò là bắt buộc",
    unableToUpdate: "Không thể cập nhật",
    orignalName: "Tên khai sinh",
    uploadedDate: "Ngày tải lên",
    fileName: "Tên tệp",
    importNum: "Số nhập khẩu",
    languagePreferences: "Tùy chọn Ngôn ngữ",
    pleaseTryAgainAfterSometime: "Xin hãy thử lại sau một vài giây",
    noChanges: "Không thay đổi",
    nothingchanged: "Không có gì thay đổi",
    pleaseChooseAnImageFile: "Vui lòng chọn một tập tin hình ảnh",
    fileIsTooBigSelectUnder1MB: "Tệp của bạn quá lớn! ",
    phoneShouldHave10Chars: "Điện thoại phải có 10 ký tự",
    onlyCSVAllowed: "Chỉ cho phép tệp CSV",
    loadingPleaseWait: "Tải vui lòng đợi",
    manager: "giám đốc",
    administrator: "người quản lý",
    Comingsoon: "Sắp ra mắt",
    totalAnimals: "Tổng số động vật",
    receivedOrders: "Đơn hàng đã nhận",
    drugs: "Thuốc",
    detailedAnalysis: "Phân tích chi tiết",
    barGraphRepOfActiveUsersAndDeactivateUsers: "Biểu đồ dạng thanh của người dùng đang hoạt động và người dùng không hoạt động",
    barGraphRepOfRegAnimalsVsFarm: "Biểu đồ thanh Biểu thị Động vật đã Đăng ký Vs Trang trại",
    roleNumber: "Số vai trò",
    roleName: "Tên vai trò",
    active: "Tích cực",
    inactive: "Không hoạt động",
    admin: "Quản trị viên",
    addRole: "Thêm vai trò",
    addRoles: "Thêm vai trò",
    permissions: "Quyền",
    sr: "Sr.",
    moduleName: "Tên mô-đun",
    view: "Xem",
    deptNo: "Số phòng ban",
    selectByCategory: "Chọn theo danh mục",
    weeklyAnalytics: "Phân tích hàng tuần",
    pregnancy: "Thai kỳ",
    analytics: "phân tích",
    calendar: "Lịch",
    productName: "tên sản phẩm",
    volumeSold: "Khối lượng đã bán",
    recordPoints: "ghi điểm",
    inStock: "Trong kho",
    revenue: "Doanh thu",
    stockStatus: "Tình trạng tồn kho",
    barChart: "Biểu đồ cột",
    lineChart: "Biểu đồ đường",
    indexReturns: "Trả về chỉ mục",
    chart: "Đồ thị",
    time: "thời gian",
    production: "Sản xuất",
    customization: "tùy biến",
    recordsPerPage: "Tài liệu từng trang",
    noDataAvailable: "Không có dữ liệu",
    reporting: "Báo cáo",
    optional: "Không bắt buộc",
    note: "Ghi chú",
    notes: "ghi chú",
    date: "Ngày",
    kG: "KILÔGAM",
    weight: "cân nặng",
    type: "Kiểu",
    lessthan3Month: "<3 tháng",
    lessthan6Month: "<6 tháng",
    lessthan7Month: "<7 Tháng",
    lastWeek: "Tuần trước",
    thisWeek: "Tuần này",
    lessthanOneYear: "<1 năm",
    lessthanTwoYear: "<2 năm",
    lessthanThreeYear: "<3 Năm",
    lessthanFourYear: "<4 Năm",
    yes: "Đúng",
    no: "KHÔNG",
    of: "của",
    notSpecified: "không được chỉ định",
    days: "ngày",
    day: "ngày",
    aDay: "một ngày",
    years: "năm",
    year: "năm",
    unit: "đơn vị",
    units: "Các đơn vị",
    to: "ĐẾN",
    profile: "Hồ sơ",
    logOut: "Đăng xuất",
    Unit: "Đơn vị",
    otherSettings: "Các thiết lập khác",
    somethingWentWrong: "một cái gì đó đã đi sai.",
    toDo: "Làm",
    loadingData: "Đang tải dữ liệu...",
    taskNumber: "số nhiệm vụ",
    taskName: "Tên nhiệm vụ",
    startDate: "Ngày bắt đầu",
    dueDate: "Ngày đáo hạn",
    reason: "Lý do",
    quantity: "Số lượng",
    cost: "Trị giá",
    noRecordFound: "Không tìm thấy bản ghi nào",
    dailyUpdates: "Cập nhật hàng ngày",
    weeklyUpdates: "Cập nhật hàng tuần",
    moduleAccessed: "Đã truy cập mô-đun",
    typesOfAccess: "Các loại truy cập",
    userId: "Tên người dùng",
    lastLogin: "Lân đăng nhập cuôi",
    terminalID: "ID thiết bị đầu cuối",
    geographicalAccessPoint: "Điểm truy cập địa lý",
    iPAddress: "Địa chỉ IP",
    fileAccessed: "Đã truy cập tệp",
    functionAccessed: "Đã truy cập chức năng",
    webPageURL: "URL trang web",
    accessType: "Loại truy cập",
    unsuccessfulLoginAttempts: "Nỗ lực đăng nhập không thành công",
    customerAddress: "Địa chỉ của khách hàng",
    orderdate: "Ngày đặt hàng",
    postageDate: "Ngày gửi thư",
    postID: "ID bài đăng",
    packingTechnician: "kỹ thuật viên đóng gói",
    packingTechnicia: "kỹ thuật đóng gói",
    packEdit: "Gói chỉnh sửa",
    batchNumber: "Số lô",
    collectionTechnician: "Kỹ thuật viên Thu gom",
    collectionTechnicia: "Bộ sưu tập kỹ thuật",
    preparationTechnicia: "Kỹ thuật chuẩn bị",
    preparationTechnician: "Kỹ thuật viên pha chế",
    approvedManually: "Phê duyệt thủ công",
    researcher: "Nhà nghiên cứu",
    dateOfApproval: "Ngày được chấp thuận",
    approvalEdit: "Phê duyệt Chỉnh sửa",
    searchByAllExceptDate: "Tìm kiếm theo tất cả ngoại trừ ngày",
    approval: "Sự chấp thuận",
    collection: "Bộ sưu tập",
    postage: "Bưu chính",
    pack: "Đóng gói",
    straws: "ống hút",
    createdAt: "tạo tại",
    sireID: "ID bố",
    economicIndexValue: "Giá trị chỉ số kinh tế",
    latestCollectionDate: "Ngày Thu gần nhất",
    locationId: "Mã vị trí",
    lastUpdated: "Cập nhật mới nhất",
    print: "In",
    save: "Cứu",
    tax: "Thuế",
    phoneNo: "Không có điện thoại",
    exportAsPDF: "Xuất dưới dạng PDF",
    statusUpdated: "Trạng thái được cập nhật",
    statusNotUpdated: "Trạng thái Chưa cập nhật",
    inProgress: "Trong tiến trình",
    assignedTo: "Phân công",
    taskId: "id nhiệm vụ",
    createdDate: "Ngày tạo ra",
    numberOfAnimals: "Số lượng động vật",
    healthRecordSubmittedSuccess: "Đã gửi hồ sơ sức khỏe thành công",
    healthRecordSubmitted: "Đã gửi hồ sơ sức khỏe.",
    InseminationRecordSubmittedSuccesful: "Hồ sơ thụ tinh đã được gửi thành công",
    inseminationRecordSubmitted: "Đã nộp hồ sơ thụ tinh.",
    actionListDailyTask: "Danh sách hành động - Nhiệm vụ hàng ngày",
    sinceLastYear: "Kể từ năm ngoái",
    sinceLastQuarter: "kể từ quý trước",
    sinceLastMonth: "Kể từ tháng trước",
    sinceLastWeek: "kể từ tuần trước",
    drugWithdrawPeriod: "Thời gian rút thuốc",
    diagnosisName: "Tên chẩn đoán",
    animalWithNoGenetype: "Động vật này không có bất kỳ dữ liệu Kiểu gen nào được đăng ký. ",
    nameOfPreviousOwner: "Tên của chủ sở hữu trước",
    avatarSize: "Kích thước hình đại diện phải nhỏ hơn 1 MB!",
    testDestination: "Điểm đến kiểm tra",
    animalNotAdded: "Động vật không được thêm vào",
    registerationSuccessful: "Đăng ký thành công",
    backToAnimalList: "Quay lại Danh sách động vật",
    addAnotherAnimal: "Thêm một con vật khác",
    animalDetailsUpdated: "Chi tiết động vật được cập nhật thành công",
    animalUpdatedSuccessfully: "Động vật được cập nhật thành công",
    animalNotUpdated: "Động vật không được cập nhật",
    notMember: "Không phải là một thành viên?",
    requestAccess: "Yêu cầu quyền truy cập",
    typePassword: "Vui lòng nhập mật khẩu.",
    minChars: "Tối thiểu 6 ký tự",
    typeConfirmPassword: "gõ xác nhận mật khẩu",
    passConfig: "Xác nhận mật khẩu không khớp.",
    invalidEmailMobile: "Định dạng email/di động không hợp lệ",
    passwordNotEmpty: "Mật khẩu không được để trống",
    passwordLength: "Độ dài mật khẩu không được nhỏ hơn 8 ký tự",
    cityVillage: "Thành phố / Xã",
    districtRegion: "Huyện, vùng",
    alreadyHaveAnAccount: "Alreday có một tài khoản?",
    genetypeUpdated: "Loại gen được cập nhật",
    genetypeNotUpdated: "Kiểu gen không được cập nhật",
    sellTrade: "Bán/Giao dịch",
    milkingDevon: "Vắt sữa giống Devon để bán",
    detailedDescription: "miêu tả cụ thể",
    longPara: "American Milking bò cái tơ và bò cái Devon Bulls. ",
    contactSeller: "Liên hệ với người bán",
    enterListingTitle: "Nhập tiêu đề danh sách",
    livestocktype: "Loại gia súc",
    uploadImage: "Tải lên một hình ảnh",
    mobilePhone: "Số điện thoại",
    myLivestock: "gia súc của tôi",
    livestockObservations: "Quan sát chăn nuôi",
    selectFromRegisteredAnimals: "Chọn từ danh sách động vật đã đăng ký",
    selectOption: "Chọn tùy chọn",
    selectTypeObservation: "Chọn loại quan sát",
    attachVeteinaryDocument: "Đính kèm tài liệu thú y",
    addsensorReading: "Thêm đọc cảm biến",
    myDocument: "Tai liệu của tôi",
    enterAKeyword: "Nhập từ khóa",
    documentType: "loại tài liệu",
    registerEditLivestock: "Đăng ký/Chỉnh sửa vật nuôi",
    editLivestockProfile: "Chỉnh sửa hồ sơ chăn nuôi",
    copy: "Sao chép",
    dateOfRegister: "Ngày đăng ký",
    livestockType: "Loại gia súc",
    registerNewLivestock: "Đăng ký gia súc mới",
    enterUniqueTag: "Nhập thẻ duy nhất",
    color: "Màu sắc",
    gender: "Giới tính",
    male: "Nam giới",
    female: "Nữ giới",
    damm: "đập",
    siree: "Bệ hạ",
    dateOfSaleAuction: "Ngày bán/bán đấu giá",
    auctionRecord: "Biên bản đấu giá Danh sách tử thần",
    distinguishingFeatures: "Tính năng phân biệt",
    keywordListing: "ID từ khóa hoặc danh sách",
    adType: "Loại quảng cáo",
    activeListingFund: "Tìm thấy 1 danh sách đang hoạt động",
    setupSensors: "Thiết lập cảm biến",
    serialNumber: "Số seri",
    sensorLocation: "Vị trí cảm biến",
    sensorType: "Loại cảm biến",
    installationDate: "Ngày cài đặt",
    ExpirationDate: "Ngày hết hạn",
    addGeo: "Thêm vị trí địa lý",
    addMoreSensors: "Thêm cảm biến khác",
    trackAndTrace: "Theo dõi và theo dõi",
    createNewShipment: "Tạo Lô hàng Mới",
    workflowReference: "Quy trình công việc tham khảo",
    invoiceDate: "Ngày hóa đơn",
    trackShipment: "Vận chuyển ... Đơn hàng",
    totalShipments: "Tổng số lô hàng",
    activeShipment: "lô hàng đang hoạt động",
    completedObjectives: "Mục tiêu đã hoàn thành",
    processedPayments: "Thanh toán đã xử lý",
    pointOfDestination: "điểm đến",
    sellerInformation: "Thông tin người bán",
    selectSellerConsignor: "Chọn Người bán/Người ký gửi",
    pointOfOrigin: "Điểm xuất phát",
    buyerInfo: "Thông tin người mua",
    selectBuyerConsignor: "Chọn Người mua/Người ký gửi",
    addSensorTriggers: "Thêm bộ kích hoạt cảm biến",
    processPayments: "xử lý thanh toán",
    defineShippingContract: "Xác định hợp đồng vận chuyển",
    addDigitize: "Thêm vào",
    currentlyOnFarm: "Hiện đang ở trang trại",
    addSire: "thêm ngài",
    addApproval: "Thêm phê duyệt",
    addCollection: "Thêm bộ sưu tập",
    addStraws: "thêm ống hút",
    addPack: "Thêm gói",
    addPostage: "Thêm bưu chính",
    searchBySire: "Tìm kiếm theo Ngài",
    anyDataChangeMightBeLost: "Mọi thay đổi dữ liệu có thể bị mất",
    wouldYouLikeToSaveOrWantToLeaveWithoutSaving: "Bạn muốn lưu hay muốn thoát mà không lưu",
    leave: "Rời khỏi",
    stay: "Ở lại",
    animalFarm: "trang trại động vật",
    animalFarmH: "trang trại động vật",
    animalOrigin: "Nguồn gốc động vật",
    animalOriginH: "Nguồn gốc động vật",
    farmOfOrigin: "trang trại xứ",
    farmOfOriginH: "trang trại xứ",
    selectFarm: "Chọn trang trại",
    searchFarm: "Trang trại tìm kiếm",
    confirmation: "xác nhận",
    proceed: "Tiếp tục",
    ok: "ĐƯỢC RỒI",
    animal: {
      tagH: "Nhãn",
      tagNumberH: "Số thẻ: Bạn có thể thêm màu cũng như số. ",
      goveRegNoH: "Số được cung cấp khi đăng ký với một tổ chức chính phủ",
      birthWeightH: "Trọng lượng sơ sinh của bê",
      birthEaseH: "Sinh sản ở vật nuôi là một quá trình tự nhiên nhưng đôi khi có thể có các vấn đề về sinh sản mà người chăn nuôi cần sự trợ giúp của người chăn nuôi/người chăn nuôi gia súc.",
      birthFarmH: "Trang trại có nguồn gốc động vật / sinh sản.",
      surrogateDamH: "ID của con bò cái trong đó trứng đã thụ tinh từ một con đực hiến tặng và con cái hiến tặng được cấy ghép để phát triển thêm.",
      ownerH: "Đây là tên của chủ sở hữu của con vật.",
      damH: "ID của phụ nữ / mẹ của động vật.",
      sireH: "ID của Nam cha/mẹ của con vật.",
      breedH: "Giống là một nhóm vật nuôi cụ thể có ngoại hình đồng nhất (kiểu hình), hành vi đồng nhất và/hoặc các đặc điểm khác giúp phân biệt nó với các sinh vật khác cùng loài.",
      conceptionMethodH: "Làm thế nào con vật được hình thành.",
      genderH: "Giới tính của động vật.",
      dobH: "Ngày sinh của con vật.",
      operatorH: "Tên của người điền thông tin của con vật này.",
      removalFarmH: "Trang trại động vật bị loại bỏ ",
      dateOfRemovalH: "Ngày loại bỏ động vật",
      destinationOfRemoval: "Nơi đến của động vật bị loại bỏ",
      reasonOfRemovalH: "Lý do loại bỏ động vật",
      trackingNumberH: "Số được gán cho con vật khi con vật bị loại bỏ",
      brandH: "Thương hiệu-Đơn giản là một nhãn hiệu vĩnh viễn được đốt cháy trên con bò.",
      tattoH: "Hình xăm trên động vật.",
      hornStatusH: "Cho dù con vật bị mất sừng.",
      animalOriginH: "Quốc gia xuất xứ của động vật.",
      previousOwnerH: "Tên chủ cũ của con vật trong trường hợp là con trưởng thành.",
      twinH: "Trường này cho biết con vật đó có sinh đôi hay không.",
      regBreedAssoNoH: "Đăng ký với Hiệp hội / Hiệp hội giống.",
      breedAssoNameH: "Tên Hiệp hội/Hiệp hội nơi động vật được đăng ký",
      breederH: "Đây là tên của tổ chức cung cấp động vật.",
      breeder: "người chăn nuôi",
      noteH: "Ghi chú quan trọng về con vật.",
      accuracyWeight_for_field: "Độ chính xác",
      conception: "Quan niệm",
      addAnAnimal: "Thêm một con vật",
      addAnimal: "Thêm động vật",
      registerAnAnimal: "Đăng ký một con vật",
      uploadAnAnimal: "Tải lên một con vật",
      animalRegistration: "Đăng ký động vật",
      animalDetails: "chi tiết động vật",
      tag: "Nhãn",
      tagNumber: "Số thẻ",
      govtRegNumber: "chính phủ ",
      birthWeight: "Cân nặng khi sinh (lbs)",
      birthEase: "dễ sinh",
      birthFarm: "trang trại sinh",
      surrogateDam: "đập thay thế",
      owner: "Người sở hữu",
      ownershipType: "Loại quyền sở hữu",
      animalDiseaseRecord: "Động VậtBệnhKỷ Lục",
      govtReg: "chính phủ ",
      regDate: "Ngày đăng ký",
      dam: "đập",
      sire: "Bệ hạ",
      heifer: "bò cái tơ",
      steer: "Chỉ đạo",
      calf: "Bắp chân",
      farmHerd: "trang trại/bầy đàn",
      femaleCalf: "bê cái",
      maleCalf: "bê đực",
      newCalves: "bê mới",
      breed: "Giống",
      conceptionMethod: "phương pháp thụ thai",
      gender: "Giới tính",
      dateOfBirth: "Ngày sinh",
      operator: "Nhà điều hành",
      animalRemovedFarm: "Trang trại động vật bị loại bỏ",
      dateOfAnimalRemoval: "Ngày loại bỏ động vật",
      destinationOfRemovedAnimal: "Điểm đến của động vật bị loại bỏ",
      reasonOfRemoval: "Lý do xóa",
      optionalAnimalInformation: "Thông tin động vật tùy chọn",
      animalPicture: "hình ảnh động vật",
      trackingNumber: "Số theo dõi",
      brand: "Thương hiệu",
      tatto: "Xăm hình",
      hornStatus: "Tình trạng sừng",
      animalOrigin: "Nguồn gốc động vật",
      previosOwner: "Previos chủ sở hữu",
      twin: "sinh đôi",
      InABreedAssociation: "Đăng ký.",
      nameOfBreedAssociations: "Tên hiệp hội giống",
      breedAssociations: "hiệp hội giống",
      breederSupplier: "Người chăn nuôi (Nhà cung cấp)",
      importAnimal: "Động vật nhập khẩu",
      loadingAnimals: "Đang tải Động vật... Vui lòng đợi",
      totalRegAnimals: "Tổng đăng ký ",
      totalPregnantAnimals: "Tổng số động vật mang thai",
      pregnantAnimalHistory: "Lịch sử động vật mang thai",
      dailyAnimalPregnancyUpdates: "Cập nhật động vật mang thai hàng ngày",
      animalHistory: "Lịch sử động vật",
      dailyAnimalUpdates: "Cập nhật động vật hàng ngày",
      totalPregnant: "Tổng số mang thai",
      totalNewBorn: "Tổng số mới sinh",
      searchByIDGOVRegTag: "Tìm kiếm theo ID, Đăng ký GOV và Thẻ",
      noANIMALAVAILABLE: "KHÔNG CÓ ĐỘNG VẬT",
      associationNumber: "Số hiệp hội",
      associationName: "Tên hiệp hội",
      destinationName: "Tên điểm đến",
      plastic: "Nhựa",
      metal: "Kim loại",
      naturalMating: "giao phối tự nhiên",
      artificialInsemination: "Thụ tinh nhân tạo",
      embryoTransfer: "Phôi được chuyển hóa",
      noAssistance: "Không hỗ trợ",
      someAssistance: "Một số hỗ trợ",
      mechanicalAssistance: "Hỗ trợ cơ khí",
      aCesareanSection: "Mổ lấy thai",
      abnormalDelivery: "giao hàng bất thường",
      male: "Nam giới",
      female: "Nữ giới",
      castrated: "thiến",
      sale: "Doanh thu",
      slaughter: "giết mổ",
      death: "Cái chết",
      theft: "trộm cắp",
      other: "Khác",
      horned: "có sừng",
      polled: "thăm dò ý kiến",
      dehorned: "mất sừng",
      details: "Chi tiết",
      performance: "Hiệu suất",
      geneticWorth: "Giá trị di truyền",
      healthRecord: "Hồ sơ sức khỏe",
      genotypeData: "Dữ liệu kiểu gen",
      reminders: "nhắc nhở",
      activityLog: "Hoạt động đăng nhập",
      activityLogDetails: "Chi tiết nhật ký hoạt động",
      editAnimal: "Chỉnh sửa động vật",
      familyInfo: "thông tin gia đình",
      breedInfo: "thông tin giống",
      identification: "Nhận biết",
      removalInfo: "Thông tin xóa",
      iDOfAnimalDam: "ID đập của động vật.",
      iDOfAnimalSire: "ID của đực giống động vật.",
      iDOfDamEmbryoUsed: "ID của đập phôi whos đã được sử dụng.",
      animalHasATwinOrNot: "Cho dù con vật có sinh đôi hay không.",
      breedType: "Loại giống",
      breedOfTheAnimal: "Đây là một giống của động vật.",
      regBreedAssociations: "Đăng ký với Hiệp hội / Hiệp hội giống.",
      nameOfAssociationsSocieties: "Tên Hiệp hội/Hiệp hội nơi động vật được đăng ký.",
      nameOfTheOrgSuppliedAnimal: "Đây là tên của tổ chức cung cấp động vật.",
      countryOriginAnimal: "Quốc gia xuất xứ của động vật.",
      birthFarmID: "ID trại sinh",
      farmIDAnimalBorn: "ID trang trại nơi con vật được sinh ra.",
      currentOwner: "Người chủ hiện tại",
      nameOfOwnerAnimal: "Đây là tên của chủ sở hữu của con vật.",
      registrationDate: "ngày đăng kí",
      previousOwner: "Chủ sở hữu trước",
      nameOfOperator: "Tên của nhà điều hành",
      dateAnimalRemoved: "Ngày mà động vật được loại bỏ.",
      destinationPlaceRemovedAnimal: "Nơi đến của động vật bị loại bỏ",
      namePersonFillAnimalInformation: "Tên của người điền thông tin của con vật này.",
      reasonOfAnimalRemoval: "Lý do loại bỏ động vật",
      reasonWhyTheAnimalIsRemoved: "Lý do tại sao con vật bị loại bỏ",
      processingDate: "Ngày xử lý",
      DateInformationFilledChanged: "Ngày thông tin hiện tại được điền hoặc thay đổi.",
      animalID: "ID động vật",
      UniqueIdAnimal: "Đây là id duy nhất của động vật.",
      plasticTagNumber: "Số thẻ nhựa",
      numberAnimalTag: "Số thẻ Động vật.",
      rFTagNumber: "Số thẻ RF",
      numberAnimalRFTag: "Số thẻ RF động vật.",
      govtRegNumb: "chính phủ ",
      govtRegistrationNumber: "Các chi tiết nhận dạng có thể bao gồm tên và địa chỉ của cá nhân, đại lý của cá nhân đó để thực hiện quy trình, địa điểm của hoạt động sẽ được thực hiện và mô tả về dịch vụ mà cá nhân đó cung cấp.",
      numberAssignedAnimalIsRemoved: "Số theo dõi là một trong những ID của động vật được sử dụng để theo dõi hoạt động của động vật.",
      dateOfAnimalRegistration: "Ngày đăng ký động vật",
      stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal: "Thương hiệu-Đơn giản là một nhãn hiệu vĩnh viễn đã được đốt cháy trên con bò.",
      tattoOnAnimal: "Hình xăm trên động vật.",
      whetherTheAnimalIsDehorned: "Cho dù con vật bị mất sừng.",
      milkingAnimals: "động vật vắt sữa",
      studAnimals: "động vật stud",
      animalInseminationRecord: "Hồ sơ thụ tinh động vật",
      numOfStrawsOrdered: "Số lượng ống hút được đặt hàng",
      totalNumOfStraws: "Tổng số ống hút",
      strawId: "Id rơm",
      addSireAutomation: "Thêm tự động hóa Sire",
      addApprovalAutomation: "Thêm tự động phê duyệt",
      addCollectionAutomation: "Thêm tự động hóa bộ sưu tập",
      addStrawsAutomation: "Thêm ống hút tự động hóa",
      addPackAutomation: "Thêm gói tự động hóa",
      addPostageAutomation: "Thêm tự động hóa bưu chính",
      searchBySire: "tìm kiếmBySire",
      numberOfProgenies: "Số con cháu",
      sireEdit: "Bệ hạ Sửa đổi",
      searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId: "Tìm kiếm theo Id ống hút, Tổng số ống hút, Số lô và Id địa điểm",
      searchByPackIdNumberOfStrawsOrderedPackingTechnicia: "Tìm kiếm theo Pack Id, Số lượng ống hút được đặt hàng, Kỹ thuật đóng gói",
      searchByCollectionAndPreparationTechnicia: "Tìm kiếm theo bộ sưu tập và kỹ thuật chuẩn bị",
      registerSemenAutomation: "Đăng ký tự động hóa tinh dịch",
      addSemenAutomation: "Thêm tự động hóa tinh dịch",
      strawAutomationRegistered: "Tự động hóa ống hút đã đăng ký",
      strawAutomationRegisteredNotRegistered: "Tự động hóa ống hút Đã đăng ký chưa đăng ký",
      sireAutomationRegistered: "Sire Automation đã đăng ký",
      sireAutomationNotRegistered: "Sire Automation chưa đăng ký",
      postageAutomationIsRegistered: "Tự động hóa bưu chính đã được đăng ký",
      postageAutomationNotRegistered: "Bưu Chính Tự Động Chưa Đăng Ký",
      packAutomationIsRegistered: "Tự động hóa gói đã được đăng ký",
      packAutomationNotRegistered: "Tự động hóa gói chưa được đăng ký",
      postageAutomationIsUpdated: "Tự động hóa bưu chính được cập nhật",
      postageAutomationNotUpdated: "Tự động hóa Bưu phí Không được Cập nhật",
      packAutomationIsUpadted: "Tự động hóa gói được cập nhật",
      packAutomationNotUpadted: "Tự động hóa gói không được cập nhật",
      collectionAutomationUpdated: "Tự động hóa bộ sưu tập Đã cập nhật",
      collectionAutomationNotUpdated: "Tự động hóa bộ sưu tập không được cập nhật",
      approvalAutomationIsUpdated: "Tự động phê duyệt được cập nhật",
      approvalAutomationIsNotUpdated: "Tự động phê duyệt không được cập nhật",
      collectionAutomationRegistered: "Tự động hóa bộ sưu tập Đã đăng ký",
      collectionAutomationNotRegistered: "Tự động hóa bộ sưu tập chưa được đăng ký",
      approvalAutomationIsRegistered: "Tự động phê duyệt đã được đăng ký",
      approvalAutomationIsNotRegistered: "Tự động phê duyệt chưa được đăng ký",
      strawAutomationUpdated: "Tự động hóa ống hút Đã cập nhật",
      strawAutomationIsNotUpdated: "Tự động hóa rơm không được cập nhật",
      searchSire: "tìm kiếm",
      strawsEdit: "Ống hút Sửa đổi",
      nextAnimals: "động vật tiếp theo",
      performanceInfo: {
        milk: "Sữa",
        liveweight: "cân nặng",
        score: "Điểm",
        fertility: "khả năng sinh sản",
        measurements: "Đo",
        dailyProteinYield: "Sản lượng protein hàng ngày",
        amountProteinMilkCowDay: "Lượng protein trong sữa thu được từ một con bò trong ngày cụ thể.",
        dailyMilkYield: "Sản lượng sữa hàng ngày",
        volumeMilkCowDay: "Khối lượng sữa thu được từ một con bò cụ thể trong một ngày cụ thể.",
        dailyFatYield: "Sản lượng chất béo hàng ngày",
        amountFatMilkCowDay: "Lượng chất béo trong sữa thu được từ một con bò trong ngày cụ thể.",
        dailyProteinContent: "Hàm lượng protein hàng ngày",
        dailyFatContent: "Hàm lượng chất béo hàng ngày",
        milkLactose: "Lactose sữa",
        amountLactoseMilk: "Lượng đường sữa trong sữa.",
        milkUrea: "urê sữa",
        indicatorAmountCrudeProtein: "Chỉ tiêu lượng protein thô trong khẩu phần ăn của bò",
        lactationNumber: "số lần cho con bú",
        ordinalNumLactation: "Số thứ tự của chu kỳ tiết sữa.",
        lengthOfLactation: "Thời gian cho con bú (ví dụ: 23 ngày)",
        lactationLength: "thời gian cho con bú",
        milkingFrequency: "tần suất vắt sữa",
        frequcnyOfMilking: "Tần suất vắt sữa (ví dụ: 2 lần/ngày)",
        liveWeightInformation: "thông tin trọng lượng sống",
        currentWeight: "Cân nặng hiện tại",
        weightAnimal: "Trọng lượng của con vật.",
        postWeaningGain: "Tăng sau cai sữa",
        dailyGainInAnimalWeightWeaning: "Tăng trọng hàng ngày của động vật sau khi cai sữa.",
        weaningWeight: "trọng lượng cai sữa",
        weightAnimalMeasuredWeaning: "Khối lượng con vật đo được trong một ngày cai sữa.",
        averageDailyGain: "Mức tăng trung bình hàng ngày",
        averageAmountWeightAnimalGainFeedingPeriod: "Trọng lượng trung bình mà một con vật sẽ tăng mỗi ngày trong thời gian cho ăn",
        carcassWeight: "trọng lượng thân thịt",
        weightAnimalsHideInternalOrgansRemoved: "Trọng lượng của con vật sau khi đã bị loại bỏ đầu, da và nội tạng.",
        weightAtCalving: "Trọng lượng lúc đẻ",
        weightAtTheTimeOfCalving: "Trọng lượng lúc đẻ.",
        yearlingWeight: "Trọng lượng hàng năm",
        weightYearOldAnimal: "Trọng lượng của động vật một năm tuổi.",
        somaticCellScore: "Điểm số tế bào soma",
        somaticCellScoreIndicatorMastitis: "Điểm số tế bào soma như một chỉ số cho bệnh viêm vú. ",
        lastUpdate: "Cập nhật cuối cùng",
        bodyConditionScore: "Chỉ số tình trạng cơ thể",
        scoreAnimalFat: "Một số điểm của động vật liên quan đến bao nhiêu chất béo mà nó có.  ",
        teatScore: "điểm núm vú",
        scoreMeasureingShapeTeats: "Điểm kích thước núm vú là đánh giá chủ quan về chiều dài và chu vi của núm vú và nằm trong khoảng từ 9 (rất nhỏ) đến 1 (rất lớn). ",
        udderScore: "Điểm treo bầu vú",
        scoreMeasureingShapeOfUdder: "Thang điểm đo hình dáng bầu vú (điểm 1-9). ",
        whetherAnimalEasyBirthDifficult: "Sinh sản ở vật nuôi là một quá trình tự nhiên nhưng đôi khi có thể có các vấn đề về sinh sản mà người chăn nuôi cần sự trợ giúp của người chăn nuôi/người chăn nuôi gia súc.",
        totalLongevity: "Tổng tuổi thọ",
        survivalLactationTraitCowCulledBreeding: "Sống sót từ chu kỳ cho con bú thứ 1 đến thứ 5. ",
        docility: "ngoan ngoãn",
        circumferenceBullScrotal: "Chu vi bìu bò",
        intervalSuccessInsemination: "Khoảng thời gian từ lần đầu tiên đến khi thụ tinh thành công.",
        ageAtFirstCalving: "Tuổi đẻ trứng đầu tiên",
        ageCowCalving: "Bò cái đẻ lứa đầu bao nhiêu tuổi.",
        calvingInterval: "khoảng đẻ",
        periodCalving: "Khoảng thời gian từ lứa này đến lứa tiếp theo.",
        scrotalCircumference: "chu vi bìu",
        estrusDetection: "Phát hiện động dục",
        trackingBehaviorAnimalDetectingEstrus: "Theo dõi hành vi vận động của động vật để phát hiện bò cái động dục.",
        presenceOfEstrus: "Sự hiện diện của động dục",
        isCowInEstrusStage: "Là khi một con bò đang ở giai đoạn động dục hoặc cũng không",
        matureWeight: "Trọng lượng trưởng thành",
        weightAnimalDefinedAge: "Trọng lượng của một con vật trong một độ tuổi xác định.",
        matureHeight: "Chiều cao trưởng thành",
        heightAnimalDefinedAge: "Chiều cao của một con vật trong độ tuổi xác định.",
        footClawSet: "Bộ vuốt chân",
        shapeAnimalClaw: "Hình dạng móng vuốt của động vật.",
        pulmonaryArterialPressure: "Áp lực động mạch phổi",
        animalBloodPreasure: "Máu của động vật.",
        footAngle: "Góc chân",
        shapeAnimalFoot: "Hình dạng bàn chân của động vật.",
        ribEyeArea: "Khu vực mắt sườn",
        amountRibEyeArea: "Số lượng diện tích mắt sườn.",
        ultrasoundFat: "Siêu âm mỡ",
        measureFatAmount: "Đo lượng chất béo.",
        ultrasoundIntramuscularFat: "Siêu âm tiêm bắp mỡ",
        ultrasoundRibEyeArea: "Siêu âm vùng sườn-mắt",
        measureRibeyeArea: "Đo diện tích xương sườn.",
        fatThickness: "Độ dày mỡ",
        amountAnimalBackFat: "Lượng mỡ lưng của động vật.",
        marbling: "cẩm thạch",
        marballingMeasurement: "Đá cẩm thạch là chất béo trong cơ không bão hòa (lành mạnh) có thể nhìn thấy tích tụ trong cơ và giữa các bó sợi cơ.",
        dryMatterIntake: "Lượng chất khô",
        amountFeedAnimalConsumesAMoisture: "Lượng thức ăn mà động vật tiêu thụ mỗi ngày trên cơ sở không có độ ẩm."
      },
      feedsName: "Tên nguồn cấp dữ liệu",
      feedName: "Tên nguồn cấp dữ liệu",
      firstFeedQuantity: "Số lượng thức ăn đầu tiên",
      additionalFeed: "Nguồn cấp dữ liệu bổ sung",
      cloversRyeGrasses: "Cỏ ba lá, Cỏ lúa mạch đen",
      greenFodderHayLegumes: "Thức ăn gia súc xanh, cỏ khô, cây họ đậu",
      feedsRegisteredSuccessfully: "Nguồn cấp dữ liệu đã đăng ký thành công",
      feedsNotRegistered: "Nguồn cấp dữ liệu chưa được đăng ký",
      fEEDQUANTITY: "SỐ LƯỢNG THỨC ĂN",
      feedQuantity: "Số lượng nguồn cấp dữ liệu",
      fEEDNAME: "TÊN NGUỒN",
      nOFEEDINFOAVAILABLE: "KHÔNG CÓ THÔNG TIN NỀN TẢNG",
      searchByFeedName: "Tìm kiếm theo tên nguồn cấp dữ liệu",
      loadingFeedInfo: "Đang tải thông tin nguồn cấp dữ liệu... Vui lòng đợi",
      todayFeedInfo: "Thông tin nguồn cấp dữ liệu hôm nay",
      feedInfo: "Thông tin nguồn cấp dữ liệu",
      loremIpsumDolorSitAmet: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
      geneticWorthInfo: {
        breedingValueEconomicIndex: "Giá trị giống này có được sử dụng để tính chỉ tiêu kinh tế hay không.",
        dailyProteinYieldUsed: "Sản lượng protein hàng ngày được sử dụng",
        weightAssignedBreedingDailyProteinYield: "Trọng số được gán cho giá trị chăn nuôi tương ứng với \"Sản lượng protein hàng ngày\". ",
        dailyProteinYieldWeight: "Sản lượng protein hàng ngày",
        rankAnimalInRelationshipEconomicIndex: "Thứ hạng của động vật trong mối quan hệ với chỉ số kinh tế.",
        economicIndexRank: "Xếp hạng chỉ số kinh tế",
        percentileEconomicIndexFall: "Phần trăm mà chỉ số kinh tế rơi vào.",
        economicIndexPercentile: "Chỉ Số Kinh Tế Phần Trăm",
        accuracyOfEconomicIndex: "Độ chính xác của chỉ số kinh tế.",
        economicIndexAccuracy: "Độ chính xác của chỉ số kinh tế",
        weightedAverageOfBreedingValues: "Bình quân gia quyền của các giá trị nhân giống.",
        economicIndex: "chỉ số kinh tế",
        rankOfAnimalInRelationshipBreeding: "Thứ hạng của động vật trong mối quan hệ với giá trị giống tương ứng.",
        dailyProteinYieldBreedingValueRank: "Năng suất protein hàng ngày xếp hạng giá trị chăn nuôi ",
        percentileBreedingFalls: "Phần trăm mà giá trị chăn nuôi rơi vào.",
        dailyProteinYieldBreedingPercentile: "Phần trăm giá trị sinh sản năng suất protein hàng ngày ",
        accuracyEstimatedBreeding: "Độ chính xác của giá trị chăn nuôi ước tính.",
        dailyProteinYieldBreedingAccuracy: "Giá trị nhân giống năng suất protein hàng ngày Độ chính xác",
        estimatedBreedingTraitDailyProteinYield: "Ước tính giá trị giống của tính trạng “Sản lượng protein hàng ngày.",
        dailyProteinYieldBreedingValue: "Giá trị nhân giống năng suất protein hàng ngày ",
        pathToTheDirectoryScriptsBreeding: "Đường dẫn đến thư mục trên ổ cứng chứa các tập lệnh được sử dụng để tính toán giá trị giống.",
        scriptsPath: "Đường dẫn tập lệnh",
        softwarePackageBreeding: "Gói phần mềm được sử dụng để tính toán giá trị giống.",
        breedingValueSoftware: "Phần mềm giá trị chăn nuôi",
        methodCalculateBreeding: "Phương pháp được sử dụng để tính toán nhân giống",
        breedingValueMethod: "Phương pháp giá trị chăn nuôi",
        trait: "Đặc điểm",
        tools: "Công cụ",
        geneticWorth: "Giá trị di truyền",
        dailyProteinYield: "Sản lượng protein hàng ngày",
        breedingValue: "Giá trị chăn nuôi",
        breedingValueBIFAccuracy: "Giá trị chăn nuôi Độ chính xác BIF",
        breedingValuePercentile: "Tỷ lệ phần trăm giá trị chăn nuôi",
        breedingValueRank: "Xếp hạng giá trị chăn nuôi",
        checkLTD: "Kiểm tra TNHH",
        ultrasoundDiagnostic: "Siêu âm chẩn đoán",
        selectYieldUsed: "Chọn Năng suất đã sử dụng",
        softwareName: "tên phần mềm",
        animalGenWorthUpdatedSuccessfully: "Animal Gen Worth được cập nhật thành công"
      },
      addNote: "Thêm ghi chú",
      enterNote: "Nhập ghi chú",
      noteIsRequired: "Lưu ý là bắt buộc",
      noteMustBeLessThan50Characters: "Lưu ý phải ít hơn 50 ký tự",
      noteAdded: "Đã thêm ghi chú",
      noteNotAdded: "Ghi chú chưa được thêm vào",
      noteForAnimal: "Lưu ý đối với động vật",
      noNoteFoundForThisAnimal: "Không tìm thấy ghi chú cho con vật này.",
      inseminationData: "Dữ liệu thụ tinh",
      nameOfInseminator: "Tên người thụ tinh",
      activity: "Hoạt động",
      searchByNameActivity: "Tìm kiếm theo tên, hoạt động",
      searchByTaskNameNumber: "Tìm kiếm theo tên nhiệm vụ, số lượng",
      inseminationDate: "Ngày thụ tinh",
      genotypeDataInfo: {
        genotypeAnimalID: "ID động vật kiểu gen",
        iDTubeBloodSampleAnimalNumberGenotypingService: "Đây là ID của một ống có mẫu máu được lấy từ động vật hoặc một số dịch vụ xác định kiểu gen",
        geneticTechnicianName: "Tên kỹ thuật viên di truyền",
        NameTechnicianBloodSamplesAnimal: "Đây là tên của một kỹ thuật viên đã lấy mẫu máu từ động vật",
        sNPData: "dữ liệu SNP",
        genotypingServiceNote: "Ghi chú dịch vụ kiểu gen",
        InfoGenotypingGenotypingTechnology: "Tất cả các thông tin liên quan đến kiểu gen như tên của công ty tạo kiểu gen, công nghệ tạo kiểu gen được sử dụng, ngày tạo kiểu gen, v.v.",
        numberOfSNPs: "Số lượng SNP",
        numberOfSNPsAnimalGenotyped: "Số lượng SNP mà động vật được xác định kiểu gen",
        nameOfTheDrug: "Tên thuốc",
        animalGenoDataUpdatedSuccessfully: "Dữ liệu gen động vật được cập nhật thành công",
        animalGenoDataNotUpdated: "Dữ liệu gen động vật không được cập nhật",
        animalIDIsRequired: "ID động vật là bắt buộc",
        techNameIsRequired: "Công nghệ. ",
        onlyAlphabetsAreAllowed: "Chỉ bảng chữ cái được phép",
        genoDataIsRequired: "Dữ liệu gen là bắt buộc",
        serviceNoteIsRequired: "Ghi chú dịch vụ là bắt buộc",
        sNPIsRequired: "SNP là bắt buộc"
      },
      healthRecordInfo: {
        treatment: "Sự đối đãi",
        treatmentTakenAnimal: "Điều trị gì đã được thực hiện trên động vật.",
        reasonOfTreatment: "Lý do điều trị",
        reasonForTreatment: "Lý do điều trị",
        whatReasonOfTreatment: "nguyên nhân điều trị là gì.",
        treatmentDate: "Ngày điều trị",
        dateOfTreatment: "Ngày điều trị.",
        diagnosis: "Chẩn đoán",
        nameDiagnosedDiseaseConditionSymptoms: "Tên của bệnh/tình trạng được chẩn đoán hoặc các triệu chứng chính",
        drugID: "ID thuốc",
        iDOfDrugWhichIsGivenToAnimal: "ID của thuốc được cung cấp cho động vật.",
        drugName: "Tên thuốc",
        nameDrugAnimal: "Tên thuốc dùng cho động vật.",
        drugWithdrawalPeriod: "Thời gian rút thuốc",
        timeAdministrationDrugAnimalMeatMilkHumanConsumption: "Thời gian cần thiết sau khi dùng thuốc cho động vật để đảm bảo an toàn cho thịt hoặc sữa cho người",
        attendingVeterinarian: "Tham gia bác sĩ thú y",
        qualifiedPersonCaseAnimal: "Người đủ điều kiện đã nhìn thấy trường hợp / động vật",
        packID: "ID gói",
        iDPackTreatment: "ID của một gói đã được sử dụng để điều trị",
        veterinarianName: "Tên bác sĩ thú y",
        animalNoHealthRecord: "Con vật này không có bất kỳ hồ sơ sức khỏe. ",
        addHealthRecord: "Thêm hồ sơ sức khỏe",
        healthStatus: "Tình trạng sức khỏe",
        loadingDiseasesPleaseWait: "Đang tải bệnh... Vui lòng đợi",
        animalDiseaseRecord: "Hồ sơ bệnh động vật",
        animalHealthRecord: "Hồ sơ sức khỏe động vật",
        animalTreatmentRecord: "Hồ sơ điều trị động vật",
        loadingHealthData: "Đang tải dữ liệu sức khỏe...",
        healthRecord: "Hồ sơ sức khỏe",
        nameOfDiagnosis: "Tên chẩn đoán",
        treatmentName: "tên điều trị",
        drugGivenBy: "Thuốc do",
        recessiveDiseases: "bệnh thoái hóa",
        recessiveDiseasesMessage: "alen lặn nào gây bệnh cho bò đực này là vật mang mầm bệnh"
      },
      conceptionInfo: {
        addNewConception: "Thêm quan niệm mới",
        semenEmbryo: "Tinh dịch/Phôi thai",
        pregnancyCheck: "khám thai",
        birthInfo: "Thông tin khai sinh",
        searchByInseminatorOrganisationBreedingConception: "Tra cứu theo Tên người phối giống, Tên tổ chức, Mã số vụ phối giống, Phương pháp thụ thai",
        deliveryDate: "Ngày giao hàng",
        calfId: "Id bê",
        birthDayOldWeight: "Sinh (Ngày Tuổi) Cân nặng",
        searchByBirthEase: "Tìm kiếm theo mức độ dễ sinh",
        searchPregnancyCheckOperatorMethod: "Tìm kiếm theo toán tử Khám thai, Phương pháp khám thai",
        pregnancyCheckDate: "Ngày khám thai",
        conceptionSuccess: "thụ thai thành công",
        pregnancyCheckOperator: "Người điều hành kiểm tra mang thai",
        pregnancyCheckMethod: "Phương pháp kiểm tra mang thai",
        recentlyPregnant: "Mang thai gần đây",
        pregnancyConfirmationDate: "Ngày xác nhận mang thai",
        pregnancyRate: "Tỷ lệ mang thai",
        timePeriodOfPregnancy: "Khoảng thời gian mang thai",
        semenProduction: "sản xuất tinh dịch",
        embryoProduction: "sản xuất phôi",
        semen: "tinh dịch",
        embryoTransferDate: "Ngày chuyển phôi",
        daysOfPregnancy: "ngày mang thai",
        searchSireEmbryoSurrogate: "Tìm kiếm theo id bố, tên tổ chức phôi, giống mẹ thay thế",
        selectDate: "Chọn ngày",
        orgnisationNameContainNumber: "Tên tổ chức không được chứa số",
        selectBirthEase: "Chọn dễ sinh",
        selectUnit: "Vui lòng chọn một đơn vị",
        animalConceptionAddedSuccessfully: "Animal Conception đã được thêm thành công",
        postageCustomerName: "Bưu chính Tên khách hàng",
        searchByPostageCustNameCustAddPostId: "Tìm kiếm theo Tên khách hàng bưu chính, Địa chỉ khách hàng, Id bưu chính",
        dateOfSemenCollection: "Ngày lấy tinh dịch",
        dateOfSemenPreparation: "Ngày chuẩn bị tinh dịch",
        semenMotility: "Tinh dịch",
        semenConcentration: "Nồng độ tinh dịch",
        postageEdit: "Bưu chính Sửa đổi",
        enterSireId: "Nhập Sre ID",
        selectEmbryoOrganisation: "Chọn tổ chức phôi",
        matingDateH: "Ngày thụ thai, giao phối tự nhiên hoặc thụ tinh nhân tạo.",
        inseminatorNameH: "Người thực hiện quy trình thụ tinh (bác sĩ thú y/kỹ thuật viên)",
        orgNameH: "Tên của tổ chức hoặc công ty cung cấp ống hút tinh dịch cho AI",
        brServiceNumH: "Ghi lại số lần sinh sản (ví dụ: lần thứ 1, thứ 2 hoặc thứ 3)",
        conceptionMethodH: "Cách con vật thụ thai là bắt đầu mang thai, được đánh dấu bằng sự thụ tinh của trứng bởi một tinh trùng.",
        sireIdH: "ID của cha/mẹ đực của con vật",
        damIdH: "ID của phụ nữ / mẹ của động vật.",
        sarogatedDamH: "ID của con bò cái trong đó trứng đã thụ tinh từ một con đực hiến tặng và con cái hiến tặng được cấy vào để phát triển thêm.",
        embOrgNameH: "Tên tổ chức của phôi",
        sarogateDamBreedH: "Ngày của giống thay thế",
        sireBreedH: "Loại đực giống (brahman, boran)",
        pregCheckDateH: "Bò có thai có thể được phát hiện sớm nhất là 30 ngày bằng siêu âm và xét nghiệm máu. Để xác định bò có thai bằng phương pháp sờ nắn, bò thường cần mang thai ít nhất 35-50 ngày. ",
        conceptionSuccessH: " Ở gia súc, tỷ lệ thụ tinh là 90% với tỷ lệ đẻ trung bình khoảng 55%, cho thấy tỷ lệ chết phôi thai khoảng 35% (Diskin et al., 2006). ",
        pregnancyCheckOperatorH: "Bác sĩ thú y và kỹ thuật viên động vật chuyên nghiệp thường cung cấp các dịch vụ này cho nông dân. ",
        pregnancyCheckMethodH: "Hai phương pháp được sử dụng phổ biến nhất để chẩn đoán mang thai ở gia súc là sờ thủ công đường sinh sản (trên trực tràng) và siêu âm qua trực tràng của đường sinh sản",
        deliveryDateH: "Ngày sinh nở",
        calfIdH: "ID của bê mới sinh",
        birthEaseH: "Sinh sản ở vật nuôi là một quá trình tự nhiên nhưng đôi khi có thể có các vấn đề về sinh sản mà người chăn nuôi cần sự trợ giúp của người chăn nuôi/người chăn nuôi gia súc.",
        birthDayOldWeightH: "Cân nặng gia cầm ngày mới đẻ hoặc cân nặng gia cầm một ngày tuổi",
        customerAddress: "Địa chỉ của khách hàng"
      },
      all: "Tất cả",
      ungrouped: "Động vật chưa được nhóm",
      active: "Động vật được nhóm",
      updateAnimal: "Cập nhật động vật"
    },
    dashboardS: {
      dailyActivities: "Các hoạt động hàng ngày",
      pendingTasks: "Các nhiệm vụ đang chờ giải quyết",
      performanceOfGeno: "Hiệu suất của kiểu gen",
      breed: "Giống",
      chromosome: "Nhiễm sắc thể",
      seqChange: "Thay đổi trình tự",
      inheritance: "Di sản",
      diseaseName: "Tên bệnh",
      refSequence: "Chuỗi tham chiếu",
      pubmedRef: "Tài liệu tham khảo đã xuất bản",
      matingDate: "Ngày giao phối",
      inseminatorName: "tên thụ tinh",
      orgName: "tên tổ chức",
      brServiceNum: "Dịch Vụ Chăn Nuôi Số",
      conceptionMethod: "phương pháp thụ thai",
      semEmbInfo: "Thông tin tinh dịch/phôi",
      sireId: "ID bố",
      damID: "ID đập",
      srgDamId: "ID đập thay thế",
      embOrgName: "Phôi Org. ",
      srgDamBreed: "Thay thế Dam Breed",
      sireBreed: "đực giống",
      damBreed: "Đầm Giống"
    },
    user: {
      selectLanguage: "Chọn ngôn ngữ",
      unitPreference: "Tùy chọn đơn vị",
      selectUnitOfMeasure: "Chọn đơn vị đo",
      importedUser: "Người dùng đã nhập",
      impFileStatus: "Nhập trạng thái tệp",
      loadingUser: "Đang tải người dùng... Vui lòng đợi",
      totalUsers: "Tổng số người dùng",
      pendingUsers: "Người dùng đang chờ xử lý",
      changePassword: "Đổi mật khẩu",
      goodIdeaToUsePassword: "Bạn nên sử dụng một mật khẩu mạnh mà bạn không sử dụng ở nơi khác.",
      enterCurrentPassword: "Nhập mật khẩu hiện tại",
      enterNewPassword: "Nhập mật khẩu mới",
      reEnterPassword: "Nhập lại mật khẩu mới",
      enterPassword: "Nhập mật khẩu",
      repeatNewPassword: "Lặp lại mật khẩu mới",
      emailAddr: "Địa chỉ email",
      enterYourPhoneNumber: "Nhập số điện thoại của bạn",
      pleaseTypeOldPassword: "Vui lòng nhập mật khẩu cũ.",
      pleaseTypeNewPassword: "Vui lòng nhập mật khẩu mới.",
      pleaseTypeConfirmPassword: "Vui lòng nhập xác nhận mật khẩu.",
      passwordChangedSuccesFully: "Đã đổi mật khẩu thành công",
      currentPassword: "Mật khẩu hiện tại",
      newPassword: "mật khẩu mới",
      passwordDoesNotMatch: "Mật khẩu không đúng.",
      emailCanNotBeEmpty: "Email không được để trống",
      profileUpdated: "Hồ sơ cá nhân đã cập nhật",
      profileNotUpdated: "Hồ Sơ Chưa Cập Nhật",
      unableToVerifyEmail: "Không thể xác minh Email",
      otpSentOnEmail: "OTP gửi về email",
      otpSentSuccessFully: "Đã gửi OTP thành công",
      importUsers: "Nhập người dùng",
      imageUpdated: "Hình ảnh được cập nhật",
      departmentName: "Tên bộ phận",
      departmentNum: "Số phòng ban",
      departmentAdded: "Đã thêm bộ phận",
      departmentNotAdded: "Bộ phận chưa được thêm vào",
      searchDepartnment: "Tìm kiếm theo tên bộ phận hoặc số",
      addDepartMent: "Thêm bộ phận",
      addDepartment: "Thêm bộ phận",
      roleNameIsRequired: "Tên vai trò là bắt buộc",
      roleNameMustBeLessThan15Chars: "Tên vai trò phải ít hơn 15 ký tự",
      roleAdded: "Đã thêm vai trò",
      editDepartment: "Bộ phận chỉnh sửa",
      departmentUpdated: "Cục cập nhật",
      departmentNotUpdated: "Bộ phận không được cập nhật",
      deleteDepartment: "Xóa bộ phận",
      deleteDepartmentMessage: "Bạn có chắc chắn muốn xóa bộ phận này.",
      noRoleAvailable: "KHÔNG CÓ VAI TRÒ",
      roleUpdated: "Đã cập nhật vai trò",
      roleNotUpdated: "Vai trò không được cập nhật",
      editRole: "Chỉnh sửa vai trò",
      allRole: "Tất cả vai trò",
      addNewRole: "Thêm vai trò mới",
      allDepartment: "tất cả các bộ phận",
      permissionsUpdated: "Quyền được cập nhật",
      permissionsnotUpdated: "Quyền không được cập nhật",
      roleNo: "Vai trò số",
      searchByEmailAndName: "Tìm kiếm theo email và tên",
      userID: "Tên người dùng",
      userUpdated: "người dùng cập nhật",
      userNotUpdated: "Người dùng không được cập nhật",
      userAdded: "Người dùng đã thêm",
      userNotAdded: "Người dùng chưa được thêm",
      activateUser: "kích hoạt người dùng",
      deactivateUser: "hủy kích hoạt người dùng",
      userStatusMsg: "Bạn có chắc chắn muốn thay đổi trạng thái người dùng",
      countryRequired: "Quốc gia là bắt buộc",
      stateRequired: "Nhà nước là bắt buộc",
      cityRequired: "Thành phố là bắt buộc",
      searchByRole: "Tìm kiếm theo Số vai trò, Tên vai trò, Bộ phận",
      noModuleAvailable: "Không có mô-đun nào",
      searchBYModuleName: "Tìm kiếm theo tên mô-đun"
    },
    farm: {
      farmID: "ID trang trại",
      onTheFarm: "Ở nông trại",
      userRoles: "Vai trò người dùng",
      adduser: "Thêm người dùng",
      addAuser: "Thêm người dùng",
      uploadUsers: "Tải người dùng lên",
      addNewUser: "Thêm người dùng mới",
      selectDept: "Chọn bộ phận",
      selectRole: "Chọn vai trò",
      editUser: "Người dùng biên tập",
      totalFarms: "Tổng số trang trại",
      NoAnimalsRegisteredForthisFarm: "Không có động vật nào được đăng ký cho trang trại này",
      farmsPerPage: "Trang trại trên mỗi trang",
      regularFarms: "Trang trại thông thường",
      farmRegisteredProducts: "Sản phẩm đã đăng ký trang trại",
      searchByFarmNameAndId: "Tìm kiếm theo Tên trang trại và Id",
      loadingProductsPleaseWait: "Đang tải sản phẩm... Vui lòng đợi",
      farmName: "Tên trang trại",
      farmLocation: "Vị trí trang trại",
      productName: "tên sản phẩm",
      stockStatus: "Tình trạng tồn kho",
      inStock: "Trong kho",
      searchByProductName: "Tìm kiếm theo tên sản phẩm",
      productCategory: "danh mục sản phẩm",
      products: "Các sản phẩm",
      farms: "trang trại",
      registerAfarm: "Đăng ký một trang trại",
      govtRegistry: "chính phủ ",
      cooperativeID: "ID hợp tác xã",
      farmType: "Loại trang trại",
      contractMating: "Giao phối hợp đồng",
      customization: "tùy biến",
      recordsPerpage: "Tài liệu từng trang",
      restoreDefault: "Khôi phục lại mặc định",
      apply: "Áp dụng",
      searchState: "Tìm kiếm theo ID trang trại, Đăng ký chính phủ, ID hợp tác xã, Loại trang trại, Giao kết hợp đồng",
      farmOwner: "chủ trang trại",
      govRegistrationNo: "Số đăng ký chính phủ",
      farmInformation: "Thông tin trang trại",
      ownershipType: "Loại quyền sở hữu",
      communityName: "Tên cộng đồng",
      farmLicenseInformation: "Thông tin giấy phép trang trại",
      licenseNumber: "Số giấy phép",
      licenseExpiryDate: "Ngày hết hạn giấy phép",
      regulatorName: "Tên cơ quan quản lý",
      regulatorRepresentativeName: "Tên đại diện cơ quan quản lý",
      farmLocationSize: "Vị trí trang trại",
      productionSystem: "Hệ thống sản xuất",
      country: "Quốc gia",
      state: "Tình trạng",
      city: "Thành phố",
      street: "Đường phố",
      houseNumber: "Số nhà",
      farmRegistration: "Đăng ký trang trại",
      cancel: "Hủy bỏ",
      register: "Đăng ký",
      ok: "Được rồi",
      totalFarmSize: "Tổng quy mô trang trại",
      farmGeographicLocation: "Vị trí địa lý trang trại",
      perimeterPointLongitude: "Kinh độ điểm chu vi",
      perimeterPointLatitude: "Vĩ độ điểm chu vi",
      perimeterPointLabel: "Nhãn điểm chu vi",
      perimeterLength: "chiều dài chu vi",
      farmLatitude: "Vĩ độ trang trại",
      farmLongitude: "kinh độ trang trại",
      editFarm: "Chỉnh sửa trang trại",
      update: "Cập nhật",
      editAfarm: "Chỉnh sửa trang trại",
      nextFarm: "trang trại tiếp theo",
      nameoftheFarm: "Tên trang trại",
      registerAProduct: " Đăng ký sản phẩm",
      farmProducts: "nông sản",
      calf: "Bắp chân",
      steer: "Chỉ đạo",
      heifer: "bò cái tơ",
      sire: "Bệ hạ",
      dam: "đập",
      registerAnAnimal: "Đăng ký một con vật",
      farmAnimals: "Động vật trong nông trại",
      farm_type: "loại trang trại",
      farm_Owner: "chủ trang trại",
      dateOfRegistration: "Ngày đăng ký",
      dataIsNotAvailableForThisFarm: "Trang trại này không có dữ liệu",
      registerNewProduct: "Đăng ký một sản phẩm mới",
      information: "Thông tin",
      licenseInfo: "Thông tin giấy phép",
      locationInfo: "Thông tin vị trí",
      geoLocation: "Vị trí địa lý",
      perimeterLengthState: "Chiều dài Chu vi trang trại (chiều dài hàng rào)",
      totalFarmSizeState: "Kích thước của một trang trại",
      productionSystemState: "Hệ thống sản xuất được sử dụng trong trang trại",
      contractMatingState: "Quy tắc của chương trình giao phối hợp đồng mà trang trại tham gia.",
      ownershipTypeState: "Loại hình sở hữu",
      regulatorRepresentativeNameState: "Tên của người đại diện cho cơ quan quản lý cấp giấy phép",
      regulatorNameState: "Tên cơ quan quản lý cấp giấy phép",
      licenseExpiryDateState: "Ngày Giấy phép hiện tại hết hạn",
      licenseNumberState: "Số giấy phép do Cơ quan quản lý phát hành",
      plotNumberState: "Số nhà của trang trại.",
      plotNumber: "Số nhà/lô đất",
      streetStatement: "Tên đường của trang trại.",
      cityStatement: "Thành phố nơi trang trại tọa lạc.",
      stateStatement: "Khu vực của quốc gia nơi trang trại tọa lạc.",
      countryState: "Quốc gia nơi trang trại tọa lạc.",
      perimeterPointLongitudeState: "Kinh độ của một điểm trên trang trại.",
      perimeterPointLatitudeState: "Vĩ độ của một điểm trên trang trại.",
      perimeterPointLabelState: "Nhãn của Điểm.",
      farmLongitudeState: "Kinh độ của trang trại.",
      farmLatitudeState: "Vĩ độ của trang trại.",
      farmNameH: "Tên trang trại",
      farmTypeH: "Loại trang trại nơi các hoạt động khác nhau được thực hiện.",
      farmOwnerH: "Tên chủ trang trại (tự động tạo tên Nông dân khi nhập thông tin)",
      ownershipTypeH: "Loại nông dân sở hữu/kiểm soát đất đai họ canh tác và những người không sở hữu.",
      govtRegNumbH: "Số đăng ký của trang trại được chỉ định bởi cơ quan quản lý",
      contractMatingH: "Mã chương trình giao phối hợp đồng mà trang trại tham gia",
      productionSystemH: "Hệ thống sản xuất nào được sử dụng trong trang trại",
      cooperativeIDH: "ID của một hợp tác xã mà trang trại là thành viên của ",
      licenseNumberH: "Số nhận dạng trên giấy phép do cơ quan quản lý phát hành để xác định giấy phép đó với chủ sở hữu.",
      licenseExpiryDateH: "Ngày giấy phép hiện tại hết hạn",
      regularNameH: "Tên cơ quan quản lý cấp giấy phép",
      regularRepName: "Tên của người đại diện cho cơ quan quản lý cấp giấy phép",
      countryH: "Quốc gia nơi trang trại tọa lạc.",
      stateH: "Khu vực của quốc gia nơi trang trại tọa lạc.",
      cityH: "Thành phố nơi trang trại tọa lạc.",
      streetH: "Tên đường của trang trại.",
      houseNumberH: "Số nhà của trang trại.",
      totalFarmSizeH: "Quy mô trang trại là tổng diện tích đất hiện đang được canh tác bởi trang trại bao gồm cả đất bỏ hoang nhưng không bao gồm đất dưới thảm thực vật tự nhiên, cây cối hoặc đồng cỏ.",
      farmLatitudeH: "Là phép đo khoảng cách về phía bắc hoặc phía nam của Xích đạo. ",
      farmLongitudeH: "Nó đo khoảng cách về phía đông hoặc phía tây của kinh tuyến gốc.",
      perimeterLengthH: "Chiều dài chu vi trang trại (chiều dài hàng rào)",
      perimeterPointLabelH: "Nhãn của điểm. ",
      perimeterPointLatH: "Vĩ độ của một điểm trên trang trại",
      perimeterPointLongH: "Kinh độ của một điểm trên trang trại",
      noProductAvailable: "Không Có Sản Phẩm",
      farmUpdated: "Cập nhật trang trại",
      performance: "Hiệu suất",
      milkInformation: "Thông tin sữa",
      farmNameRequired: "Tên trang trại là bắt buộc"
    },
    login: {
      welcome: "Chào mừng! ",
      welInfo: "Nhập thông tin đăng nhập của bạn.",
      login: "Đăng nhập",
      forgotPassword: "Quên mật khẩu",
      forgotPasswordDesc: "Vui lòng nhập địa chỉ email liên kết với tài khoản của bạn. ",
      backToLogin: "Quay lại đăng nhập"
    },
    actionListmod: {
      actionList: "Danh sách hành động",
      tODAY: "Hôm nay",
      createTask: "Tạo nhiệm vụ",
      myActivities: "Hoạt động của tôi",
      jhonSmith: "Jhon Smith",
      farmID: "ID trang trại",
      dateOfEvent: "Ngày sự kiện",
      actionRequired: "Cần hành động",
      actionTaken: "Hành động",
      animalEventID: "ID sự kiện động vật",
      cANCEL: "Hủy bỏ",
      cONFIRM: "Xác nhận",
      sTATEMENT: "Bạn có chắc chắn muốn xóa hồ sơ này?",
      dAY: "Ngày",
      wEEK: "Tuần",
      mONTH: "Tháng",
      sUBMIT: "Nộp",
      startDate: "Ngày bắt đầu",
      endDate: "Ngày cuối",
      rEPEAT: "Lặp lại",
      taskCategory: "Danh mục nhiệm vụ",
      pRIORITY: "Sự ưu tiên",
      aSSIGNEE: "người được giao",
      selectLocation: "Chọn địa điểm",
      selectAnimals: "Chọn một hoặc nhiều con vật",
      dESCRIPTION: "Sự miêu tả",
      customRecurrence: "Tái phát tùy chỉnh",
      repeatEvery: "lặp lại mỗi",
      taskName: "Tên nhiệm vụ",
      enterDescription: "Nhập mô tả",
      toDo: "Làm",
      assignTo: "Giao cho",
      status: "Trạng thái",
      nOTE: "Ghi chú",
      noTaskAvailable: "KHÔNG CÓ NHIỆM VỤ NÀO",
      healthRecord: "Hồ sơ sức khỏe",
      iD: "NHẬN DẠNG",
      tAG: "Nhãn",
      dateOfbirth: "Ngày sinh",
      taskTakenat: "nhiệm vụ được thực hiện lúc",
      gENDER: "Giới tính",
      bREED: "Giống",
      regDate: "Đăng ký. ",
      updateHealthRecord: "Cập nhật hồ sơ sức khỏe cho động vật",
      treatment: "Sự đối đãi",
      reasonOftreatment: "lý do điều trị",
      treatmentDate: "Ngày điều trị",
      dIAGNOSIS: "Chẩn đoán",
      drugId: "Id thuốc",
      drugName: "Tên thuốc",
      drugWithdrawalperiod: "Thời gian rút thuốc",
      attendingVeterinarian: "Tham gia bác sĩ thú y",
      packId: "Id gói",
      noItemsselected: "Không có mục nào được chọn",
      healthRecordsubmission: "Gửi hồ sơ sức khỏe",
      inseminationRecordsubmission: "Nộp hồ sơ thụ tinh",
      inseminatorName: "tên thụ tinh",
      inseminatorId: "Id người thụ tinh",
      conceptionRate: "Tỷ lệ thụ thai",
      dateOfmeasurement: "Ngày đo",
      recordSubmission: "Gửi hồ sơ",
      uPDATE: "Cập nhật",
      updateTask: "Cập nhật tác vụ"
    },
    inseminatorStatisticsInfo: {
      addInseminatorInfo: "Thêm thông tin về máy gieo tinh",
      inseminatorNumber: "số thụ tinh",
      loadingInseminatorPleaseWait: "Loading Inseminator... Vui lòng đợi",
      searchByIDAndName: "Tìm kiếm theo ID và Tên",
      inseminatorInfoAdded: "Đã thêm thông tin về người gieo tinh",
      inseminatorInfoNotAdded: "Thông tin về máy gieo tinh chưa được thêm vào",
      inseminatorInfoUpdated: "Cập nhật thông tin về máy gieo tinh",
      inseminatorInfoNotUpdated: "Thông tin về máy gieo tinh không được cập nhật",
      editAInseminatorInfo: "Chỉnh sửa thông tin Inseminator",
      inseminatorList: "Danh sách thụ tinh",
      inseminatorInfoDetails: "Thông tin chi tiết về máy gieo tinh",
      updateInseminatorInfo: "Cập nhật thông tin máy gieo tinh"
    },
    organizationNtrInfo: {
      loadingOrdersPleaseWait: "Đang tải đơn hàng... Vui lòng đợi",
      addStocks: "Thêm cổ phiếu",
      addStock: "thêm chứng khoán",
      quantity: "Số lượng",
      selectUnit: "Chọn đơn vị",
      farmProducts: "nông sản",
      cost: "Trị giá",
      transactionID: "ID giao dịch",
      recipientID: "ID người nhận",
      orderID: "ID đơn đặt hàng",
      recepientName: "Tên người nhận",
      createAOrder: "Tạo đơn hàng",
      totalStocks: "Tổng kho",
      orders: "đơn đặt hàng",
      totalPending: "Tổng số đang chờ xử lý",
      totalDelivered: "Tổng số đã giao",
      searchByRecepientNameOrderIdRecepientId: "Tìm kiếm theo Tên người nhận, Id đơn hàng, Id người nhận",
      chooseTheDate: "Chọn ngày",
      transactionDate: "Ngày Giao dịch",
      selectCategory: "Chọn danh mục",
      volumeOfProduct: "khối lượng sản phẩm",
      productQuantity: "Chất lượng sản phẩm",
      productRecipientId: "Id người nhận sản phẩm",
      productRecipientName: "Tên người nhận sản phẩm",
      productRecipientType: "Loại người nhận sản phẩm",
      singleProduct: "Sản phẩm đơn lẻ",
      orderPlaced: "Đa đặt hang",
      orderNotPlaced: "Đơn hàng chưa được đặt",
      totalPrice: "Tổng giá",
      currency: "Tiền tệ",
      selectCurrency: "Chọn tiền tệ",
      address: "Địa chỉ",
      enterAddress: "Nhập địa chỉ",
      attachments: "tệp đính kèm",
      chooseFile: "Chọn tập tin",
      nameOfTheFarm: "Tên trang trại",
      loremIpsumHasBeenTheIndustrySStandardDummyText: "Lorem Ipsum là văn bản giả tiêu chuẩn của ngành kể từ những năm 1500, khi một nhà in không xác định lấy một",
      billedTo: "Hóa đơn cho",
      orderStatus: "Tình trạng đặt hàng",
      selectStatus: "Chọn trạng thái",
      cadbury: "Cadbury",
      totalAmount: "Tổng cộng",
      deliveryCharges: "Phí vận chuyển",
      orderDetails: "Chi tiết đặt hàng",
      deliveryOnTime: "Giao hàng đúng hạn",
      productID: "ID sản phẩm",
      productRegistration: "Đăng ký sản phẩm",
      enterTheNameOfTheProduct: "Nhập tên của sản phẩm",
      nameOfTheProduct: "Tên của sản phẩm",
      productAdded: "Đã thêm sản phẩm",
      productNotAdded: "Sản phẩm chưa được thêm vào"
    },
    drug: {
      dRUGS: "Thuốc",
      registerAdrug: "Đăng ký thuốc",
      sEARCH: "Tìm kiếm",
      genericName: "Tên chung",
      manufacturer: "nhà chế tạo",
      distributor: "Nhà phân phối",
      registrationDate: "ngày đăng kí",
      drugRegistration: "Đăng ký thuốc",
      drugInformation: "Thông tin thuốc",
      packExpiration: "Hết hạn gói",
      drugId: "ID thuốc",
      drugName: "Tên thuốc",
      drugGenericname: "Tên thuốc gốc",
      drugManufacturer: "Nhà sản xuất thuốc",
      distributorName: "Tên nhà phân phối",
      drugRegistrationdate: "Ngày đăng ký thuốc",
      nextDrug: "Thuốc tiếp theo",
      editDrug: "Chỉnh sửa thuốc",
      updateDrug: "cập nhật thuốc",
      deleteDrug: "Xóa thuốc",
      noRecordfound: "Không tìm thấy bản ghi nào",
      addDrug: "thêm thuốc",
      statementDrug: "Thuốc đã bị xóa.  ",
      cANCEL: "Hủy bỏ",
      cONFIRM: "Xác nhận",
      sTATEMENT: "Bạn có chắc chắn muốn xóa hồ sơ này?",
      ok: " Được rồi",
      information: "Thông tin",
      packOrder: "gói đặt hàng",
      packPrescription: "gói theo toa",
      packReservation: "gói đặt trước",
      packLocation: "Vị trí đóng gói",
      drugDozedam: "Liều Thuốc Trong Một Ngày Đối Với Đam Mê",
      drugDozecalf: "Liều lượng thuốc trong một ngày cho bê",
      drugFormate: "Định dạng thuốc",
      drugDistributor: "nhà phân phối thuốc",
      drugActiveingridents: "Hoạt chất thuốc",
      drugSubstitutionId: "Id thay thế thuốc",
      packId: "Id gói",
      packBatchNumber: "Số lô đóng gói",
      drugIdStatement: "Số lô của thuốc.",
      drugNameSatement: "Tên thương hiệu được quảng cáo theo đó thuốc được bán.",
      drugGenericnameStatement: "Thành phần hóa học của một loại thuốc chứ không phải tên thương hiệu được quảng cáo mà thuốc được bán.",
      drugFormateSatement: "Số lô của thuốc.",
      drugDozecalfSatement: "Để biết liều lượng thuốc cho bê.",
      drugDozedamStatement: "Để biết liều lượng thuốc cần đập.",
      drugManufacturerStatement: "Thông tin chi tiết của nhà sản xuất thuốc.",
      drugDistributorStatement: "Thông tin chi tiết về nhà phân phối thuốc.",
      drugRegistrationdateStatement: "Ngày đăng ký thuốc tại quốc gia cụ thể.",
      drugActiveingridentsStatement: "Danh sách các thành phần hoạt động.",
      drugSubstitutionIdStatement: "ID của thuốc có thể thay thế trong trường hợp thuốc chính hiện không có sẵn.",
      packIdStatement: "Mã vạch hoặc RF ID của gói hàng.",
      packBatchNumberStatement: "Số lô được nhà sản xuất gán cho gói.",
      locationWarehouseID: "Mã kho vị trí",
      locationWarehouseIDState: "ID của kho nơi gói được lưu trữ.",
      locationRackID: "ID giá đỡ vị trí",
      locationRackIDStatement: "ID của giá nơi gói được lưu trữ.",
      locationTierID: "ID cấp vị trí",
      locationTierIDStatement: "ID của tầng trên giá nơi lưu trữ gói.",
      locationPositionID: "Vị trí ID vị trí",
      locationPositionIDStatement: "ID của vị trí trên một bậc mà gói được lưu trữ.",
      storageTemperatureCondition: "Điều kiện nhiệt độ bảo quản",
      storageTemperatureConditionStats: "Điều kiện lưu trữ gói.",
      containerForm: "Biểu mẫu thùng chứa",
      containerFormStatement: "Hình thức bao bì trong đó thuốc được đóng gói.",
      consistQuantity: "Bao gồm số lượng",
      consistQuantityStatement: "Số lượng thuốc, chai, vv trong gói.",
      releaseId: "Id phát hành",
      releaseIdStatement: "ID được chỉ định sau khi nông dân lấy gói hàng.",
      releaseDate: "Ngày phát hành",
      releaseDateStatement: "Ngày nông dân lấy gói hàng ra khỏi kho.",
      packManufacturedDate: "Ngày sản xuất gói",
      packManufacturedDateStatement: "Ngày gói được sản xuất.",
      packImportedDate: "Ngày nhập gói",
      packImportedDateStatement: "Ngày khi gói được nhập khẩu.",
      packExpirationDate: "Ngày hết hạn gói",
      packExpirationDateStatement: "Ngày khi gói hết hạn.",
      expiredSoonFlag: "Cờ sắp hết hạn",
      expiredSoonFlagState: "Cảnh báo về gói sắp hết hạn.",
      packTotalVolumeLeft: "Đóng gói Tổng khối lượng còn lại",
      packTotalVolumeLeftState: "Tổng số gói có cùng thành phần còn lại trong kho.",
      packOrderID: "ID đặt hàng gói",
      packOrderIDState: "ID đã được chỉ định sau khi đặt hàng gói từ nhà phân phối.",
      packQuantityOrdered: "Gói số lượng đặt hàng",
      packQuantityOrderedState: "Số gói đã được đặt hàng từ nhà phân phối.",
      packPrice: "Giá gói",
      packPriceStatement: "Giá gói.",
      priceCurrency: "Giá tiền tệ",
      packPricecurrency: "Đơn vị tiền tệ giá gói",
      packPricecurrencyState: "Tên tiền tệ trong đó giá được chỉ định.",
      packPaydate: "Ngày trả gói",
      payDate: "Ngày trả tiền",
      packPaydateState: "Ngày thanh toán được phát hành cho nhà phân phối.",
      packShippingID: "Gói vận chuyển ID",
      shippingID: "ID vận chuyển",
      packShippingIdState: "Id vận chuyển của gói hàng khi nó được gửi đến từ nhà phân phối.",
      packShippingDate: "Gói vận chuyển ngày",
      shippingDate: "Ngày vận chuyển",
      packShippingDateState: "Ngày đến của gói tại kho.",
      packOrderStatus: "Trạng thái đơn hàng đóng gói",
      packOrderStatusState: "Tình trạng đơn hàng hiện tại.",
      recepientKeeperId: "Id Người giữ Người nhận",
      recepientKeeperIdStatement: "Tên cá nhân/tổ chức nhận gói.",
      recepientFarmId: "Id trang trại người nhận",
      recepientFarmIdStatement: "ID của trang trại nơi chứa thuốc thú y.",
      recepientAnimalId: "Id động vật người nhận",
      recepientAnimalIdState: "ID của động vật mà (gói) thuốc được kê đơn.",
      specialistComments: "Ý kiến ​​chuyên gia",
      specialistCommentsState: "Nhận xét của bác sĩ chuyên khoa/thú y về đơn thuốc.",
      specialistName: "Tên chuyên gia",
      specialistNameState: "Tên của bác sĩ chuyên khoa/thú y đã kê đơn thuốc.",
      specialistID: "ID chuyên gia",
      specialistIDState: "ID của bác sĩ chuyên khoa/thú y đã kê đơn thuốc.",
      reservedByKeeperId: "Dành riêng bởi ID người giữ",
      reservedByKeeperIdState: "ID người giữ của người đã đặt gói.",
      reservedByFarmId: "Dành riêng bởi Id trang trại",
      reservedByFarmIdState: "ID trang trại dành riêng gói cho.",
      reservationTimeoutDate: "Ngày hết hạn đặt trước",
      reservationTimeoutDateState: "Ngày đặt trước sẽ tự động bị hủy nếu gói không được mua.",
      reservationTimeout: "Hết thời gian đặt trước",
      reservationTimeoutState: "Số giờ sau đó đặt trước sẽ tự động bị hủy nếu gói không được mua hoặc lấy",
      reservationDate: "Ngày đặt phòng",
      reservationDateState: "Ngày đặt trước của gói.",
      reservationStatus: "Tình trạng đặt trước",
      reservationStatusState: "Trạng thái đặt trước gói. ",
      loadingDrugsPleaseWait: "Đang tải thuốc... Vui lòng đợi",
      quantityOrder: "Số lượng đặt hàng",
      keeperID: "ID thủ môn",
      timeoutDate: "Ngày hết hạn",
      warehouseID: "Mã kho hàng",
      rackID: "ID giá đỡ",
      tierID: "ID cấp độ",
      positionID: "ID vị trí",
      temperatureCondition: "Điều kiện nhiệt độ",
      manufactureDate: "Ngày sản xuất",
      importedDate: "Ngày nhập khẩu",
      totalVolumeLeft: "Tổng khối lượng còn lại"
    },
    reports: {
      myReports: "Báo cáo của tôi",
      satelliteReports: "Báo cáo vệ tinh",
      weatherReports: "Dự báo thời tiết",
      pregnancyAnalytics: "Phân tích mang thai",
      semenEmbroyAnalytics: "Phân tích tinh dịch/phôi",
      semenAnalytics: "Phân tích tinh dịch",
      embryoAnalytics: "Phân tích phôi",
      calfAnalytics: "Phân tích bê",
      milkProduction: "sản xuất sữa",
      totalMilkType: "Tổng số loại sữa",
      totalAnimalAnalytics: "Tổng phân tích động vật",
      animalAnalytics: "Phân tích động vật",
      analyticsAndReporting: "Phân tích và Báo cáo",
      filterByCountry: "Lọc theo quốc gia",
      filterByFarm: "Lọc theo trang trại",
      filterByRegion: "Lọc theo vùng",
      filterByMonth: "Lọc theo tháng",
      filterByDate: "Lọc theo ngày",
      filterByRole: "Lọc theo vai trò",
      filterByYear: "Lọc theo năm",
      filterByTrait: "Lọc theo đặc điểm",
      avgBreedingValue: "Giá trị chăn nuôi trung bình",
      avgEconomicIndex: "Chỉ số kinh tế trung bình",
      breederReport: "báo cáo người chăn nuôi",
      semenTransferDate: "Ngày Chuyển Tinh Dịch",
      semenEmbryoProductionReport: "Báo cáo sản xuất tinh dịch/phôi",
      semenProducts: "sản phẩm tinh dịch",
      meatProducts: "Sản phẩm thịt",
      totalProducts: "Tổng số sản phẩm",
      semenEmbryoReport: "Báo cáo tinh dịch/phôi",
      numOfStraws: "Số ống hút",
      collectionDate: "Ngày thu tiền",
      productionReport: "Báo cáo sản xuất",
      receipientId: "ID người nhận",
      embryoId: "ID phôi",
      semenStrawId: "ID ống hút tinh dịch",
      dataScientist: "Nhà khoa học dữ liệu",
      dataScientistReport: "Báo cáo của nhà khoa học dữ liệu",
      productReport: "Báo cáo sản phẩm",
      dairyProducts: "sản phẩm từ sữa"
    },
    genoPerformance: {
      performanceOfGenoType: "Hiệu suất của GenoType",
      addAGenoType: "Thêm một kiểu gen",
      breedName: "Tên giống",
      chromosome: "Nhiễm sắc thể",
      sequenceChange: "Thay đổi trình tự",
      inheritance: "Di sản",
      diseaseName: "Tên bệnh",
      referenceSequence: "Chuỗi tham chiếu",
      pubmedReference: "Tài liệu tham khảo đã xuất bản",
      genoTypeRegistration: "Đăng ký kiểu gen",
      breed: "Giống",
      editAGenoType: "Chỉnh sửa GenoType",
      editGenoType: "Chỉnh sửa kiểu gen",
      loadingGene: "Đang tải Geno... Vui lòng đợi",
      geneTypeList: "Danh sách kiểu gen"
    },
    reportings: {
      conception: "Quan niệm (Nhà khoa học dữ liệu)",
      performanceOfGenoData: "Hiệu suất của kiểu gen (Nhà khoa học dữ liệu)",
      totalInsemination: "thụ tinh toàn phần",
      embryo: "Phôi thai",
      animalVaccinationRecord: "Hồ sơ tiêm phòng động vật",
      dataNotAvailable: "Dữ liệu không có sẵn cho Trang trại này.",
      pregnancyStatus: "Tình trạng mang thai",
      healthReport: "Báo cáo sức khỏe",
      heavyMilk: "sữa đặc",
      standardMilk: "Sữa tiêu chuẩn"
    },
    sidebar: {
      healthAnalytics: "Phân tích sức khỏe",
      productionAnalytics: "Phân tích sản xuất"
    },
    epd: {
      regNo: "Animal Reg No là mã duy nhất được cấp cho động vật bằng cách sử dụng phương tiện đánh dấu, đảm bảo quy trình được thực hiện để xác định và theo dõi các động vật cụ thể",
      internationalID: "ID quốc tế của động vật",
      location: "Quốc gia / Khu vực sinh sản của động vật ",
      animalName: "Tên tiêu chuẩn / Danh pháp của động vật",
      gender: "Giới tính của động vật (đực/cái)",
      additionalIDMethod: "Phương pháp nào đã được sử dụng để xác định con vật (ví dụ: thẻ tai, hình xăm)",
      damID: "ID hoặc Số đăng ký của đập của động vật-cha mẹ của động vật/ID của Số của mẹ ruột",
      sireId: "ID hoặc số Đăng ký của bố mẹ đực của động vật, đặc biệt là bò đực được nuôi để nhân giống hoặc tinh dịch bò đực được sử dụng để Thụ tinh Nhân tạo.",
      dateOfBirth: "Ngày sinh của con vật.",
      breederHerdCode: "Breeder Herd Code chủ yếu được cung cấp bởi Hiệp hội Breeder",
      seasonofBirth: "Mùa sinh của động vật được ghi nhận trong tháng khôn ngoan",
      birthYear: "Năm con vật sinh ra",
      birthManagementCode: "Mã quản lý sinh hầu hết được cung cấp bởi người dùng/nông dân",
      birthSex: "Giới tính của động vật (đực/cái)",
      birthWeight: "Trọng lượng sơ sinh của bê ",
      primaryBreed: "Chính % đóng góp di truyền của động vật ",
      secondaryBreed: "Đóng góp % di truyền nhỏ của động vật ",
      breedComposition: "Tỷ lệ phần trăm thành phần giống đề cập đến sự đại diện theo tỷ lệ của các giống khác nhau trong cấu trúc di truyền của một cá thể động vật hoặc một nhóm động vật. ",
      conceptionMethod: "Con vật được hình thành như thế nào (giao phối tự nhiên/thụ tinh/chuyển phôi).",
      accuracyWeight: "Độ chính xác",
      damAge: "Tuổi của đập theo tháng/năm, ví dụ: ",
      weaningWeight: "Cai sữa Trọng lượng của một con vật tại thời điểm cai sữa.",
      weaningDate: "Ngày mà con vật được cai sữa",
      weaningSex: "Giới tính của con vật đã được cai sữa. ",
      managementPastureCode: "Mã do người dùng/nông dân cấp cho quản lý/đồng cỏ ",
      creep: "Cho ăn tập ăn là thực hành cung cấp thức ăn bổ sung (ngũ cốc hoặc thức ăn thô xanh) cho bê con đang bú.",
      weaningContemporaryGroupCode: "Quy tắc ăn dặm theo cân nặng của nhóm đương đại",
      birthContemporaryCode: "Mã đương đại sinh",
      yearlingDate: "Ngày con vật được một tuổi hoặc năm thứ hai của tuổi nó",
      managementFeedUnitCode: "Mã do người dùng cung cấp cho đơn vị quản lý/nguồn cấp dữ liệu",
      yearlingSex: "Giới tính của con vật vào thời điểm một năm tuổi ",
      yearlingWeight: "Trọng lượng con một năm là phép đo tốc độ tăng trưởng trực tiếp sau cai sữa và thường được sử dụng để phản ánh năng suất tiềm năng của con non hướng tới thị trường trong cơ sở vỗ béo, được đo bằng pound bê.",
      yearlingHeight: "Chiều cao của con vật tại thời điểm một năm tuổi ",
      yearlingWeightContemporaryGroupCode: "Code of Yearling Weight Nhóm đương đại",
      weaningYearlingWeightContemporaryGroupCode: "mã của nhóm Đương đại Trọng lượng cai sữa hoặc một tuổi",
      daysOnFeed: "Số ngày được cho ăn bằng loại thức ăn cụ thể đó Ví dụ: gia súc non đang phát triển được cho ăn chế độ ăn nhiều năng lượng để sản xuất thịt bò bán được với chi phí tăng trọng thấp. ",
      managementFeedUnitPenCode: "Mã do người dùng cung cấp cho đơn vị quản lý/nguồn cấp dữ liệu/bút",
      harvestDate: "Ngày giết mổ (giết) động vật để lấy thịt",
      gradingDate: "Ngày của thân thịt được phân loại theo một tiêu chí cụ thể",
      carcassSex: "Giới tính của thân thịt",
      dateonFeed: "Ngày con vật được chuyển sang thức ăn mới Ví dụ: gia súc non đang phát triển được cho ăn chế độ ăn giàu năng lượng để sản xuất thịt bò bán được với chi phí tăng trọng thấp. ",
      KPH: "% KPH là tỷ lệ phần trăm tổng lượng chất béo được tìm thấy trong khoang cơ thể của thân thịt, cụ thể là ở các vùng thận, xương chậu và tim. ",
      carcassWeight: "Trọng lượng thân thịt là trọng lượng nóng hoặc không ướp lạnh sau khi thu hoạch và loại bỏ da, đầu, đường tiêu hóa và các cơ quan nội tạng. ",
      fatThickness: "Độ dày của mỡ được đo bằng inch bằng thước nhỏ. ",
      marbling: "Đá cẩm thạch là chất béo trong cơ không bão hòa (lành mạnh) có thể nhìn thấy tích tụ trong cơ và giữa các bó sợi cơ.",
      ribeyeArea: "Lượng diện tích mắt sườn (cơ thăn hoặc cơ xương sườn longissimus dorsi) được đo giữa xương sườn thứ 12 và 13 tính bằng inch vuông bằng cách sử dụng lưới (ví dụ: 8, 9 hoặc 10 inch). ",
      animalStatus: "Tình trạng của động vật trong trang trại, ví dụ: khỏe mạnh, ốm yếu, v.v."
    },
    manageAnimalGroupings: {
      resetModeTooltip: "\n        CHẾ ĐỘ ĐẶT LẠI <br>\n            trong chế độ này <br>\n            1) Đặt/xác định tất cả các đặc điểm của các nhóm đương đại (CG) cho tất cả các đặc điểm quan tâm. <br>\n            2) Gán tất cả các con vật vào một CG tương ứng. <br>\n            3) Nếu việc chỉ định động vật không thỏa đáng, hãy điều chỉnh/thay đổi CG, sau đó chỉ định lại động vật cho CG mới tương ứng. <br>\n            4) Lặp lại các bước trên, nếu cần, cho đến khi bạn hài lòng với CG và phân nhóm/chỉ định động vật tương ứng.<br>\n        ",
      maintainanceModeHeadingTooltip: "Sau khi XÁC LẬP LẠI (chế độ) được hoàn tất, bạn sẽ vào CHẾ ĐỘ BẢO TRÌ trong đó các EDP được tính toán khi THIẾT LẬP LẠI sẽ được giữ cố định cho mỗi con vật cho đến LẦN THIẾT LẬP LẠI tiếp theo (có thể là 2-6 tháng nữa). ",
      maintainanceModeTooltip: "Sau khi hoàn thành CHẾ ĐỘ CÀI ĐẶT LẠI, hãy nhấn nút HOÀN THÀNH CÀI ĐẶT LẠI để cho phép hệ thống tính toán EPD của tất cả động vật, Chấm dứt CHẾ ĐỘ CÀI ĐẶT LẠI và bắt đầu CHẾ ĐỘ BẢO TRÌ.",
      resetToggleTooltip: "Bật Đặt lại Chuyển đổi trong cài đặt mô hình EPD để gán động vật cho CG."
    },
    geneticsAndBreeding: {
      geneticsAndBreeding: "di truyền học",
      geneticSearchTool: "Công cụ tìm kiếm di truyền",
      dataSubmission: "Gửi dữ liệu / Lựa chọn động vật",
      animalsWithExpectedProgenyDifferences: "Lựa chọn động vật để tính toán sự khác biệt về thế hệ con cháu dự kiến ​​(EPD)",
      searchByAnimalIdName: "Tìm kiếm theo Id động vật, tên",
      rowsPerPage: "Hàng trên mỗi trang",
      individualEntry: "Bài dự thi cá nhân",
      bulkEntry: "nhập số lượng lớn",
      registerANewAnimalOrSelectAnExistingAnimal: "Đăng ký một con vật mới hoặc chọn một con vật hiện có.",
      registerNewAnimal: "Đăng ký động vật mới",
      selectExistingAnimal: "Chọn động vật hiện có",
      animalID: "ID động vật",
      animalName: "Tên động vật",
      tag: "Nhãn",
      dateOfBirth: "Ngày sinh",
      gender: "Giới tính",
      birthDate: "Ngày sinh",
      birthWeightLb: "Cân nặng khi sinh (lb)",
      birthWeightKg: "Cân nặng khi sinh (kg)",
      weaningWeightLb: "Trọng lượng cai sữa (lb)",
      weaningWeightKg: "Trọng lượng cai sữa (kg)",
      yearlingWeightLb: "Trọng lượng hàng năm (lb)",
      yearlingWeightKg: "Trọng lượng hàng năm (kg)",
      carcassWeightLb: "Trọng lượng thân thịt (lb)",
      carcassWeightKg: "Trọng lượng thân thịt (kg)",
      animalSelection: "Lựa chọn động vật",
      animalSearchTool: "Công cụ tìm kiếm động vật",
      back: "Mặt sau",
      searchByEPDs: "Tìm kiếm theo EPD",
      searchByIds: "Tìm kiếm theo ID",
      selectBreed: "Chọn giống",
      selectGender: "Chọn giới tính",
      selectRequiredBreedForCattle: "Chọn Con Giống Cần Thiết Cho Gia Súc",
      resetFilter: "ĐẶT LẠI BỘ LỌC",
      birthWeightHeader: "Cân nặng khi sinh (BW): ",
      birthWeightDef: "So sánh sự khác biệt về trọng lượng của bê khi sinh và được đo bằng pound hoặc kg.",
      weaningWeightHeader: "Trọng lượng cai sữa (WW): ",
      weaningWeightDef: "WW EPD là ước tính về tốc độ tăng trưởng trước cai sữa được đo bằng pound hoặc kg.",
      yearlingWeightHeader: "Trọng lượng hàng năm (YW): ",
      yearlingWeightDef: "YW EPD là ước tính về tốc độ tăng trưởng sau cai sữa được đo bằng pound hoặc kg.",
      ribEyeAreaHeader: "Khu vực Ribeye(REA): ",
      ribEyeAreaDef: "REA đo kích thước của cơ mang lại cho chúng ta xương sườn theo inch vuông.REA EPD phản ánh sự khác biệt trong phép đo diện tích xương sườn 365 ngày đã điều chỉnh dựa trên các phép đo thân thịt của gia súc được thu hoạch.",
      marblingHeader: "Đá cẩm thạch (MARB): ",
      marblingDef: "MARB EPD tính theo đơn vị tỷ lệ phần trăm của chất béo tiêm bắp trong xương sườn. MARB EPD phản ánh sự khác biệt trong điểm số bi 365 ngày đã điều chỉnh (mỡ tiêm bắp, [IMF]) dựa trên phép đo thân thịt của gia súc được thu hoạch.",
      fatThicknessHeader: "Độ dày mỡ (FAT): ",
      fatThicknessDef: "Inch mỡ lưng (tính bằng phần trăm inch) là đơn vị đo lường cho FT.",
      carcassWeightHeader: "Trọng lượng thân thịt (CW): ",
      carcassWeightDef: "Trọng lượng thân thịt là một đặc điểm có lợi khi xem xét tác động của cân đối với giá trị sản phẩm cuối cùng. ",
      yieldGradeHeader: "Cấp năng suất (YG): ",
      yieldGradeDef: "Hệ thống tính điểm của USDA Yield Grade là đơn vị đo lường cho YG EPD. ",
      milkHeader: "Sữa(MK): ",
      milkDef: "MK EPD được đo bằng pound trọng lượng cai sữa của bê do khả năng vắt sữa của bò mẹ.",
      totalMaternalHeader: "Tổng số bà mẹ (TM): ",
      totalMaternalDef: "TM đo lường tác động đến trọng lượng cai sữa của bê do cả sản xuất sữa và di truyền của bò đối với sự tăng trưởng.",
      calvingEaseDirectHeader: "Calvining dễ dàng trực tiếp (CED): ",
      calvingEaseDirectDef: "CED EPD được liệt kê dưới dạng phần trăm số ca sinh không được hỗ trợ.",
      calvingEaseMaternalHeader: "Bà mẹ dễ đẻ (CEM): ",
      calvingEaseMaternalDef: "Đo lường khả năng sinh bê của các con gái của một con bò đực khi chúng được hai tuổi.",
      stayabilityHeader: "Khả năng ở lại (STAY): ",
      stayabilityDef: "ST EPD dự đoán khả năng của một con bò đực sinh ra những con cái “ở quanh quẩn”. ",
      docilityHeader: "Sự ngoan ngoãn (DOC): ",
      docilityDef: "DOC đo tính khí của gia súc.",
      max: "TỐI ĐA",
      min: "TỐI THIỂU",
      accuracy: "SỰ CHÍNH XÁC",
      sortBy: "Sắp xếp theo",
      traits: "Các đặc điểm hiển thị bằng màu xám đang được phát triển và sẽ ra mắt vào quý 2 năm 2023.",
      searchResults: "kết quả tìm kiếm",
      recordsFound: "dữ liệu được tìm thấy",
      compareSelected: "SO SÁNH ĐÃ CHỌN",
      animalIdentification: "Nhận dạng động vật",
      errorMessage: {
        birthWeight: "Giá trị cân nặng khi sinh tối đa không thể nhỏ hơn giá trị Cân nặng khi sinh tối thiểu",
        weaningWeight: "Giá trị khối lượng cai sữa tối đa không được nhỏ hơn Khối lượng cai sữa tối thiểu",
        yearlingWeight: "Giá trị tối đa của Trọng lượng con một năm không được nhỏ hơn Trọng lượng con một năm tối thiểu",
        carcassWeight: "Giá trị tối đa của trọng lượng thân thịt không được nhỏ hơn Trọng lượng sơ sinh tối thiểu",
        fatThickness: "Giá trị tối đa Độ dày mỡ không thể nhỏ hơn Trọng lượng cai sữa tối thiểu",
        marbling: "Giá trị tối đa của đá cẩm thạch không thể nhỏ hơn trọng lượng tối thiểu theo năm",
        ribeyeArea: "Giá trị tối đa của Vùng Ribeye không thể nhỏ hơn Cân nặng khi sinh tối thiểu",
        yieldGrade: "Giá trị tối đa của Hạng Năng suất không thể nhỏ hơn Trọng lượng cai sữa tối thiểu",
        milk: "Giá trị tối đa của sữa không được thấp hơn trọng lượng tối thiểu của trẻ cai sữa"
      },
      reg: "đăng ký",
      name: "Tên",
      sex: "giới tính",
      tattoo: "Xăm hình",
      dob: "DOB",
      EPD: "EPD",
      rank: "Thứ hạng",
      searchValue: "Giá trị tìm kiếm",
      typeHere: "Nhập ở đây",
      searching: "Đang tìm kiếm...",
      fetchingResult: "Đang tìm nạp kết quả...Vui lòng đợi",
      animalsMatchedYourCriteria: "Động vật phù hợp với tiêu chí của bạn",
      manageAnimalsGrouping: "Quản lý nhóm động vật",
      manageAnimalGroupings: "Quản lý nhóm động vật",
      assignAnimalToContemporaryGroups: "Gán động vật cho các nhóm đương đại",
      resetMode: "Đặt lại chế độ",
      enterResetMode: "Vào Chế độ Đặt lại",
      maintainanceMode: "Chế độ bảo trì",
      assigningAnimals: "chỉ định động vật",
      excludedAnimals: "Động vật bị loại trừ",
      ungroupedAnimals: "Động vật chưa được nhóm",
      assignAnimalsToCGS: "Chỉ định động vật cho CGS",
      reset: "Cài lại",
      excludeAnimals: "Loại trừ Động vật",
      resetToMaintainanceMode: "Đặt lại đã hoàn tất - Thay đổi sang Chế độ bảo trì",
      contemporaryGroupsSettings: "Cài đặt nhóm đương đại (CG)",
      selectTrait: "Chọn đặc điểm",
      selectTraitDescription: "Chọn Đặc điểm đề cập đến quá trình chọn một đặc điểm cụ thể",
      traitsType: {
        birthWeight: "Cân nặng khi sinh",
        weaningWeight: "Trọng lượng cai sữa",
        yearlingWeight: "Trọng lượng hàng năm",
        carcassWeight: "Trọng lượng thân thịt"
      },
      addNewGroup: "THÊM NHÓM MỚI",
      contemporaryGroup: "Nhóm đương đại",
      contemporaryGroups: "Nhóm đương đại",
      editGroup: "Chỉnh sửa nhóm",
      birthCGCode: "Mã khai sinh(CG)",
      groupName: "Tên nhóm",
      birthSex: "giới tính sinh",
      conceptionMethod: "phương pháp thụ thai",
      weaningCGCode: "Mã cai sữa (CG)",
      yearlingCGCode: "Mã hàng năm (CG)",
      dateWeight: "Ngày Trọng lượng",
      weaningyearlingCGcode: "Mã Cai sữa/Yearling (CG)",
      carcassCGCode: "Mã thân thịt (CG)",
      breedOfDom: "Giống Đầm",
      addNewContemporaryGroup: "Thêm nhóm đương đại mới",
      createNewGroup: "Tạo nhóm mới",
      selectFromDifferentTraits: "Chọn từ các đặc điểm khác nhau",
      contemporaryGroupName: "Tên nhóm đương đại",
      enterNameHere: "Nhập tên ở đây",
      groupNameIsRequired: "Tên nhóm là bắt buộc",
      birthYearRange: "Phạm vi năm sinh",
      theYearAnimalWasBorn: "Con vật năm được sinh ra",
      birthYearIsRequired: "Năm sinh là bắt buộc",
      genderOfNewBornAnimal: "Giới tính của động vật mới sinh",
      selectSex: "Chọn giới tính",
      theweightOfAnimalAtBirth: "Trọng lượng con vật khi sinh",
      maximumKg: "tối đa",
      minimumKg: "tối thiểu",
      aSeasonisAPeriodOfYear: "Một mùa là một khoảng thời gian trong năm được phân biệt bởi các điều kiện khí hậu đặc biệt.",
      seasonofBirthIsRequired: "Mùa sinh là bắt buộc",
      majorGenericContributionOfAnimal: "Chính % đóng góp chung của động vật",
      primaryBreedCompostionIsRequired: "Yêu cầu phân giống sơ cấp",
      secondaryBreedCompostionIsRequired: "Phân giống thứ cấp là bắt buộc",
      howTheAnimalWasConceived: "Con vật được hình thành như thế nào (giao phối tự nhiên/thụ tinh/chuyển phôi)",
      conceptionMethodIsRequired: "Phương pháp thụ thai là bắt buộc",
      epdModelSettings: "Cài đặt mô hình EPD",
      forResetMode: "Đối với Chế độ Đặt lại",
      progenyWeightingFactor: "Yếu tố trọng số thế hệ con cháu",
      weightGivenToTheProgenyFactor: "Trọng số được cung cấp cho hệ số con so với hệ số CG để tính toán EPD ở chế độ Đặt lại. ",
      enterNumber: "Nhập số",
      enterBreed: "nhập giống",
      valueShouldBeBetween0and1: "Giá trị phải nằm trong khoảng từ 0 đến 1",
      resetDuration: "Đặt lại thời lượng",
      timeIntervalBetweenLastAndFirstResetMode: "Khoảng thời gian giữa chế độ đặt lại mới và chế độ đặt lại mới, khi kết thúc chế độ đặt lại mới được bật và các CG và EPD mới được tính toán.",
      enterNumberOfDays: "Nhập số ngày",
      valueCannotBeNegative: "Giá trị không được âm!",
      criticalProgenyPopulation: "Quần thể thế hệ quan trọng",
      minimumNumberOfProgenyRecords: "Số lượng hồ sơ thế hệ con cháu tối thiểu của từng động vật trong hệ thống cần thiết để đạt được Độ chính xác thế hệ con cháu (APD1) trên 50% (đối với Độ chính xác phả hệ)",
      criticalAncestorPopulation: "Quần thể tổ tiên quan trọng",
      minimumNumberOfAncestorsRecords: "Số lượng hồ sơ tổ tiên tối thiểu của từng động vật trong hệ thống cần thiết để đạt được Độ chính xác về tổ tiên (APD4) trên 50% (đối với Độ chính xác phả hệ)",
      forBirthWeightCG: "Cân nặng khi sinh CG",
      criticalPopulationInAnimalsContemporaryGroup: "Dân số quan trọng trong nhóm đương đại của động vật",
      minimumAverageNumberOfAnimalsPerBirthWeight: "Số lượng động vật trung bình tối thiểu trên mỗi Trọng lượng sơ sinh CG cần thiết để đạt được Độ chính xác CG trung bình (ACG3) trên 50%",
      criticalAveragePopulationPerContemporaryGroup: "Dân số trung bình quan trọng trên mỗi nhóm đương đại",
      minimumNumberOfAnimalsInBirthWeight: "Số lượng động vật tối thiểu trong CG Trọng lượng sơ sinh của động vật cần thiết để đạt được Độ chính xác CG (ACG2) trên 50%",
      forWeaningWeightCG: "Đối với trọng lượng cai sữa CG",
      minimumAverageNumberOfAnimalsPerWeaningWeight: "Số con trung bình tối thiểu trên mỗi trọng lượng cai sữa CG cần thiết để đạt được Độ chính xác CG trung bình (ACG3) trên 50%",
      minimumNumberOfAnimalsInWeaningWeight: "Số con tối thiểu trong CG trọng lượng cai sữa của con vật cần thiết để đạt được Độ chính xác CG (ACG2) trên 50%",
      forYearlingWeightCG: "Đối với trọng lượng hàng năm CG",
      minimumAverageNumberOfAnimalsPerYearling: "Số lượng động vật trung bình tối thiểu trên CG một năm cần thiết để đạt được Độ chính xác CG trung bình (ACG3) trên 50%",
      minimumNumberOfAnimalsInYearlingWeight: "Số lượng động vật tối thiểu trong CG trọng lượng một năm của động vật cần thiết để đạt được Độ chính xác CG (ACG2) trên 50%",
      forCarcassCG: "Đối với thân thịt CG",
      minimumAverageNumberOfAnimalsPerCarcassWeight: "Số lượng động vật trung bình tối thiểu trên mỗi trọng lượng thân thịt CG cần thiết để đạt được Độ chính xác CG trung bình (ACG3) trên 50%",
      minimumNumberOFAnimalInCarcassWeight: "Số lượng động vật tối thiểu trong CG trọng lượng thân thịt của động vật cần thiết để đạt được Độ chính xác CG (ACG2) trên 50%",
      epdRequiredFieldSettings: "Cài đặt trường bắt buộc EPD",
      pleaseSelectRequiredFieldsForCompleteEPD: "Vui lòng chọn các trường bắt buộc để tính toán EPD hoàn chỉnh",
      byDefault: "theo mặc định",
      pleaseNoteThatUsersNotAbleToObtainFullEPD: "Lưu ý: Xin lưu ý rằng người dùng sẽ không thể có được phép tính EPD đầy đủ nếu họ không cung cấp các trường dữ liệu mà bạn đánh dấu là bắt buộc.",
      pleaseNoteThatRequiredFieldParametersCannotBeChanged: "Lưu ý: Xin lưu ý rằng không thể thay đổi các tham số trường bắt buộc vì đã có các nhóm hiện đại so với các tham số trước đó.",
      noResultFound: "KHÔNG CÓ KẾT QUẢ NÀO",
      next: "Kế tiếp",
      cancel: "Hủy bỏ",
      selectAnimal: "Chọn động vật",
      searchBy: "Tìm kiếm bởi",
      breed: "Giống",
      regDate: "Đăng ký. ",
      status: "Trạng thái",
      animalDetails: "chi tiết động vật",
      add: "Thêm vào",
      update: "Cập nhật",
      dataForEPDs: " Dữ liệu cho EPD",
      basicInformation: "Thông tin cơ bản",
      birthWeightInformation: "Thông tin cân nặng khi sinh",
      weaningWeightInformation: "Thông tin cân nặng cai sữa",
      yearlingWeightInformation: "Thông tin trọng lượng hàng năm",
      carcassWeightInformation: "Thông tin trọng lượng thân thịt",
      delete: "Xóa bỏ",
      deleteEpdData: "Xóa dữ liệu EPD",
      areYouSureYouWantToDeleteEpdData: "Bạn có chắc chắn muốn xóa dữ liệu EPD không.",
      internationalID: "ID quốc tế",
      enterID: "Nhập ID",
      animalRegistration: "Đăng ký động vật",
      location: "Vị trí",
      additionalIDMethod: "Phương pháp ID bổ sung",
      damID: "ID đập",
      sireID: "ID bố",
      breederHerdCode: "Mã đàn chăn nuôi",
      birthYear: "năm sinh",
      primaryBreed: "giống chính",
      breedComposition: "Thành phần giống",
      secondaryBreed: "Giống thứ cấp",
      seasonofBirth: "mùa sinh",
      birthManagementCode: "Mã quản lý khai sinh",
      damAge: "Hư hại",
      years: "năm",
      birthContemporaryCode: "Mã đương đại sinh",
      accuracyWeight: "Độ chính xác",
      note: "Ghi chú",
      minimumRequiredFieldForBirthWeight: "Trường bắt buộc tối thiểu đối với EPD cân nặng khi sinh",
      birthYearGenderConceptionMethodBirthWeight: "Năm sinh , Giới tính , Phương pháp thụ thai , Cân nặng khi sinh",
      weaningWeight: "Trọng lượng cai sữa",
      weaningDate: "Ngày cai sữa",
      weaningContemporaryGroupCode: "Mã nhóm đương đại cai sữa",
      creep: "Leo",
      managementPastureCode: "Mã quản lý/đồng cỏ",
      weaningSex: "quan hệ tình dục cai sữa",
      minimumRequiredFieldForWeaningWeight: "Trường bắt buộc tối thiểu cho EPD Cân nặng cai sữa",
      weaningWeightManagementPastureCodeWeaningSexDateWeighed: "Trọng lượng cai sữa , Quản lý / Mã đồng cỏ , Giới tính cai sữa , Ngày cân",
      yearlingWeight: "Trọng lượng hàng năm",
      yearlingHeight: "Chiều cao hàng năm",
      yearlingDate: "Ngày niên hiệu",
      yearlingContemporaryGroupCode: "Mã nhóm đương đại Yearling",
      managementFeedingCode: "Quản lý/Mã nguồn cấp dữ liệu",
      yearlingSex: "Quan hệ tình dục hàng năm",
      youWillNeedToFillOutFor: "Bạn sẽ cần điền vào tất cả các trường để truy xuất dữ liệu EPD cho",
      pleaseSelectHavestDateFirstToEnterInfo: "Trước tiên, vui lòng chọn 'Ngày thu hoạch' để nhập thông tin cho Vùng mắt sườn, Độ dày mỡ và Đá cẩm thạch",
      harvestDate: "Ngày thu hoạch",
      dateOnFeed: "Ngày trên nguồn cấp dữ liệu",
      daysOnFeed: "Số ngày trên nguồn cấp dữ liệu",
      gradingDate: "Ngày chấm điểm",
      carcassSex: "Thân thịt Tình dục",
      carcassWeight: "Trọng lượng thân thịt",
      carcassContemporary: "thân thịt đương đại",
      damBreed: "Đầm Giống",
      ribEyeArea: "Vùng mắt sườn",
      ribEyeAreaContemporary: "Khu vực mắt sườn đương đại",
      fatThickness: "Độ dày mỡ",
      fatThicknessContemporary: "Độ dày mỡ Đương đại",
      marbling: "cẩm thạch",
      marblingContemporary: "đá cẩm thạch đương đại",
      yieldGradeContemporary: "Cấp năng suất Đương đại",
      animalsNotListedInContemporaryGroupsMsg: "Động vật chưa được thêm vào bất kỳ nhóm hiện đại nào do thiếu thông tin. ",
      listOfUngroupedAnimals: "Danh sách động vật Ungrouped",
      submittingData: "gửi dữ liệu",
      resendToUser: "Gửi lại cho người dùng",
      submittingAnimalsInGroupMsg: "Gửi động vật của bạn thành các nhóm. ",
      pressingResetBtnMsg: "Nhấn nút \"Đặt lại\" sẽ bắt đầu quá trình gán lại động vật cho các nhóm hiện tại của chúng.",
      doYouWantToProceed: "Bạn có muốn tiếp tục ?",
      systemMaintainanceModeMsg: "Nhấn nút \"Chuyển sang Chế độ Bảo trì\" sẽ bắt đầu một quy trình và hệ thống của bạn sẽ chuyển sang “CHẾ ĐỘ BẢO TRÌ” trong đó các EDP được tính toán khi THIẾT LẬP LẠI sẽ được giữ cố định cho mỗi con vật cho đến lần THIẾT LẬP LẠI tiếp theo (có thể là 1-6 tháng ",
      errorFetchingContemporaryGrpMsg: "Lỗi khi tìm nạp dữ liệu nhóm hiện tại",
      deleteSuccess: "Xóa thành công",
      deleteSuccessMsg: "Nhóm đương đại đã xóa thành công.",
      deleteFailed: "Xóa không thành công",
      deleteFailedMsg: "Lỗi khi xóa dữ liệu nhóm hiện tại",
      deleteContemporaryGrpMsg: "Bạn có chắc chắn muốn xóa nhóm đương đại này không?",
      addBirthWeightData: "Thêm dữ liệu cân nặng khi sinh",
      addWeaningWeightData: "Thêm dữ liệu cân nặng cai sữa",
      birthWeightContemporaryGroupCode: "Cân nặng khi sinh Mã nhóm đương đại",
      dateWeighted: "Ngày có trọng số",
      addYearlingWeightData: "Thêm dữ liệu trọng lượng hàng năm",
      addCarcassWeightData: "Thêm dữ liệu trọng lượng thân thịt",
      weaningOrYearlingContemporaryGroupCode: "Cân nặng cai sữa hoặc con một tuổi Mã nhóm đương đại",
      deleteContemporaryGroupMsg: "Bạn có chắc chắn muốn xóa nhóm đương thời không?",
      updateSuccessMsg: "Nhóm đương đại đã cập nhật thành công.",
      errorMsg: "Đã xảy ra sự cố. ",
      fetchErrorMsg: "Lỗi khi tìm nạp các trường bắt buộc cho đặc điểm đã chọn.",
      forMaintainanceMode: "Đối với Chế độ bảo trì",
      ancestorsWeightFactor: "Yếu tố trọng lượng tổ tiên",
      weightGivenToTheAncestorFactor: "Trọng số được cung cấp cho hệ số tổ tiên so với hệ số CG để tính toán EPD trong chế độ Bảo trì. ",
      addEPDModelSettingsData: "Thêm Dữ liệu Cài đặt Mô hình EPD",
      minimumNumberOfAnimalsInContemporaryGroups: "Số lượng động vật tối thiểu trong các nhóm đương đại",
      enterNumberOfAnimals: "Nhập số lượng động vật",
      areYouSureYouWantToChangeEPDCalculation: "Bạn có chắc chắn muốn thay đổi các trường tính toán EPD bắt buộc không?",
      weightOfAnimalAtBirth: "Trọng lượng của động vật khi sinh",
      seasonIsAPeriodOfYear: "Một mùa là một khoảng thời gian trong năm được phân biệt bởi các điều kiện khí hậu đặc biệt.",
      codeOfBirthWeightContemporaryGroup: "Mã Tổ Trọng Sinh Đương Thời",
      weaningWeightOfCalf: "Khối lượng bê cai sữa",
      dateAnimalWasWeaned: "Ngày con vật được cai sữa",
      genderOfWeaningAnimal: "Giới tính của động vật cai sữa",
      yearlingWeightOfCalf: "Cân nặng hàng năm của bê",
      dateAnimalWasWeighted: "Ngày con vật được cân",
      yearledAnimalSex: "Giới tính của con vật đã được một năm tuổi",
      dateOfAnimalKilledForMeat: "Ngày động vật bị giết để lấy thịt",
      addSuccessMsg: "Đã thêm thành công nhóm đương đại",
      traitH: "Tính trạng để tính EPD.",
      searchByValue: "Nhập Số đăng ký/Hình xăm/Tên/Thẻ"
    },
    listView: "Chế độ xem danh sách",
    Month: "tháng",
    Week: 'tuần',
    Day: 'ngày',
    dailyTask: 'Nhiệm vụ hàng ngày',
    addTask: 'Thêm nhiệm vụ',
    todayPending: "Hôm nay đang chờ xử lý",
    loadingTaskMsg: "Đang tải nhiệm vụ hàng ngày... Vui lòng đợi",
    task: "nhiệm vụ",
    actions: "hành động",
    userGuide: "Hướng dẫn sử dụng",
    goToabout: "Chuyển đến Giới thiệu",
    userGuideD: {
      head: "Hướng dẫn sử dụng di truyền và nhân giống",
      headDetails1: "Quản trị viên phải tuân theo hai quy trình đầu tiên bên dưới để tính toán EPD (Sự khác biệt về thế hệ con cháu dự kiến) của động vật trong hệ thống. Các EPD sau đó có thể được sử dụng để đánh giá động vật và cải thiện giống (tức là các đặc điểm) của các thế hệ tương lai của chúng",
      headDetails2: "Dữ liệu động vật cần thiết được cung cấp bởi người gây giống/người nông dân/người dùng như được mô tả trong dòng cuối cùng bên dưới.",
      head2: "Luồng chế độ đặt lại - dành cho Người dùng quản trị",
      head3: "Luồng chế độ bảo trì - Dành cho người dùng quản trị",
      head4: "Luồng dữ liệu đầu vào bắt buộc - Dành cho Người chăn nuôi/Nông dân/Người dùng",
      subHead1: "Lựa chọn Động vật cho Tính toán EPD",
      subHead2: "Cài đặt mô hình EPD",
      subHead3: "Cài đặt trường EPD bắt buộc",
      subHead4: "Cài đặt nhóm đương đại (CG)",
      subHead5: "Chỉ định động vật cho các nhóm đương đại (CG)",
      subHead6: "Hoàn thành Chế độ Đặt lại để Chuyển sang Chế độ Bảo trì",
      subHead7: "Tính toán EPD",
      subHead8: "Chế độ bảo trì",
      subHead9: "Chuyển về Chế độ đặt lại để cập nhật EPD",
      subHead10: "Dữ liệu đầu vào bắt buộc",
      desc1: "Quản trị viên nên chọn các động vật trong hệ thống để đưa vào Tính toán EPD",
      desc2: "Quản trị viên nên đọc mô tả của mô hình và nhập cài đặt của mô hình",
      desc3: "Đối với mỗi đặc điểm quan tâm (ví dụ: Cân nặng khi sinh, Cân nặng cai sữa, v.v.), Quản trị viên nên kiểm tra các trường bắt buộc để xác định nhóm đương đại (CG)",
      desc4: "Tại trang Nhóm đương thời, Quản trị viên nhấn nút [THÊM NHÓM MỚI] để đến trang Thêm nhóm đương đại mới. Sau đó, đối với từng đặc điểm quan tâm và đối với từng QTCT khác nhau, Quản trị viên nên đặt phạm vi cho các trường cần thiết để xác định một QTCT cụ thể (đã đánh dấu vào mục 3 ở trên) trong các ô được đánh dấu màu vàng. Mỗi CG nên có một phạm vi khác nhau của các lĩnh vực đó.",
      desc5: "Trong khi ở Chế độ Đặt lại, Quản trị viên nên chỉ định các động vật được chọn trong phần 1 ở trên cho các CG được xác định trong phần 4 ở trên bằng cách nhấn nút [ASSIGN ANIMALS TO CGs].",
      desc6a: "Nếu sau khi chỉ định động vật trong hệ thống cho các CG (trong mục 5 ở trên), quản trị viên hài lòng với cách phân phối động vật giữa các CG (do quản trị viên xác định trong mục 4 ở trên), thì quản trị viên nên chuyển sang Chế độ bảo trì bằng cách nhấn [ THIẾT LẬP LẠI CUỐI CÙNG - THAY ĐỔI SANG CHẾ ĐỘ BẢO TRÌ].",
      desc6b: "Nếu sau khi chỉ định động vật trong hệ thống cho các CG (trong mục 5 ở trên), quản trị viên KHÔNG hài lòng với cách phân phối động vật giữa các CG (do quản trị viên xác định trong mục 4 ở trên), thì quản trị viên có thể bắt đầu lại Chế độ Đặt lại, bằng cách nhấn nút Nút [REINITIATE RESET FLOW] và điều chỉnh lựa chọn động vật và CG bằng cách lặp lại các bước 1 - 6 ở trên (nhiều lần, nếu cần) cho đến khi đạt được 6a ở trên, tại thời điểm đó, Chế độ Đặt lại hoàn tất và hệ thống được chuyển sang Chế độ Bảo trì.",
      desc7: "Tại thời điểm Chế độ Đặt lại hoàn tất và Chế độ Bảo trì được bắt đầu, EPD của tất cả các động vật kết thúc trong CG được tính toán và các giá trị EPD đó vẫn giữ nguyên trong toàn bộ Chế độ Bảo trì. Quản trị viên có thể xem các giá trị EPD của động vật bằng cách sử dụng màn hình “Công cụ Tìm kiếm Di truyền / Động vật”.",
      desc8: "Quản trị viên có thể ở chế độ bảo trì trong bất kỳ khoảng thời gian nào (ngày, tuần hoặc tháng). EPD của động vật mới được thêm vào hệ thống trong Chế độ bảo trì được tính toán bằng phương pháp khác, nếu động vật mới được thêm vào có các giá trị thông số cần thiết cho phép tính đó.",
      desc9: "Sau vài tuần hoặc vài tháng ở chế độ Bảo trì, Quản trị viên nên quay lại Chế độ Đặt lại để tính toán chính xác hơn EPD của tất cả động vật, đặc biệt là những động vật mới được thêm vào trong chế độ Bảo trì cuối cùng này. Do đó, Quản trị viên nên khởi động lại quy trình Chế độ đặt lại (được mô tả trong mục 1-6 ở trên) và sau đó là Quy trình chế độ bảo trì (được mô tả trong mục 7-9 ở trên) và chu trình này có thể được lặp lại liên tục trong nhiều năm.",
      desc10: "EPD của động vật chỉ được tính toán nếu hệ thống có các giá trị của các tham số của động vật cần thiết để tính toán EPD của động vật (các tham số cần thiết được đặt ở mục 3 ở trên). Theo đó, người chăn nuôi/người chăn nuôi/người sử dụng phải lập kế hoạch ghi chép thường xuyên, chính xác và cung cấp dữ liệu phù hợp về vòng đời của nhiều thế hệ động vật của họ.",
    },
    epdD: {
      eighteight: "Hereford Hitam Murni 88%",
      otherResults: "Hasil Lainnya",
      Horn_Poll_Scur: "Klakson/Poll/Scur",
      pedigree: "Silsilah",
      progeny: "Keturunan",
      performance: "Pertunjukan",
      ownerDetail: "Detil Pemilik",
      expectedProgeny:"Perbedaan Progeni yang Diharapkan (EPD)",
      gen5: "Silsilah 5 Generasi",
    }
  }